/**
 * @todo
 * Set up streamlinehq icons
 * import StreamlineIcon from '@streamlinehq/streamline-icons-react';
 * import { Cash } from '@streamlinehq/streamline-mini-bold/lib/money-shopping';
 * export const CashBag = props => <StreamlineIcon icon={Cash.MoneyCashBagDollar} {...props} />;
 */

import React from 'react';

export const BarGraph = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" {...props}>
      <path d="M2.918 12.923a2.918 2.918 0 0 1 2.919 2.918v5.24a2.918 2.918 0 0 1-5.837 0v-5.24a2.918 2.918 0 0 1 2.918-2.918zM11 0a2.918 2.918 0 0 1 2.918 2.918v18.164a2.918 2.918 0 0 1-5.836 0V2.918A2.918 2.918 0 0 1 11 0zm8.082 7.385A2.918 2.918 0 0 1 22 10.303v10.779a2.918 2.918 0 0 1-5.837 0V10.303a2.918 2.918 0 0 1 2.919-2.918z" />
    </svg>
  );
};

export const InvoiceInBeta = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
        d="M7 0a7 7 0 107 7 7 7 0 00-7-7zm.75 11.135v.615a.75.75 0 01-1.5 0v-.617a2.518 2.518 0 01-1.724-2.014.751.751 0 011.485-.219A1 1 0 008 8.75a.768.768 0 00-.465-.7l-1.661-.717A2.262 2.262 0 014.5 5.25a2.5 2.5 0 011.75-2.385V2.25a.75.75 0 011.5 0v.617a2.518 2.518 0 011.724 2.014.751.751 0 01-.632.852.741.741 0 01-.853-.633A1 1 0 006 5.25a.768.768 0 00.465.705l1.661.712A2.262 2.262 0 019.5 8.75a2.5 2.5 0 01-1.75 2.385z"
        transform="scale(1.85)"
      ></path>
    </svg>
  );
};

export const Task = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={24} height={24} viewBox="0 0 112 140" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M91 21H77C77 9.402 67.598 0 56 0S35 9.402 35 21H21C9.402 21 0 30.402 0 42v77c0 11.598 9.402 21 21 21h70c11.598 0 21-9.402 21-21V42c0-11.598-9.402-21-21-21zm-4.312 51.688l-35 35a8.75 8.75 0 01-12.376 0l-14-14a8.751 8.751 0 0112.376-12.376l7.812 7.812 28.812-28.812a8.751 8.751 0 0112.376 12.376z" />
    </svg>
  );
};

export const Briefcase = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="23" viewBox="0 0 25 23">
      <path d="M21.59 4.6h-3.408V3.45c0-1.906-1.526-3.45-3.41-3.45h-4.545C8.344 0 6.818 1.544 6.818 3.45V4.6H3.41C1.526 4.6 0 6.145 0 8.05v11.5C0 21.455 1.526 23 3.41 23h18.18c1.884 0 3.41-1.545 3.41-3.45V8.05c0-1.905-1.526-3.45-3.41-3.45zM9.09 3.45c0-.635.51-1.15 1.137-1.15h4.546c.628 0 1.136.515 1.136 1.15V4.6H9.091V3.45z" />
    </svg>
  );
};

export const Clock = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
      <path d="M12.5 0C5.596 0 0 5.597 0 12.5 0 19.404 5.596 25 12.5 25S25 19.404 25 12.5C25 5.597 19.404 0 12.5 0zm4.213 15.106a1.136 1.136 0 0 1-1.607 1.607l-3.41-3.41a1.136 1.136 0 0 1-.332-.803V5.682a1.136 1.136 0 0 1 2.272 0v6.348l3.077 3.076z" />
    </svg>
  );
};

export const Cog: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" {...props}>
      <path d="M15.627 6.617h-.61c-.15 0-.391-.184-.494-.449a6.37 6.37 0 0 0-.115-.278c-.115-.26-.075-.56.032-.667l.43-.43a1.375 1.375 0 0 0 .001-1.943l-.72-.72a1.365 1.365 0 0 0-.971-.403c-.367 0-.712.143-.972.403l-.43.43c-.063.063-.19.102-.332.102a.848.848 0 0 1-.336-.07 6.528 6.528 0 0 0-.278-.114c-.265-.103-.45-.343-.45-.495v-.61A1.373 1.373 0 0 0 9.01 0H7.991c-.757 0-1.373.616-1.373 1.374v.61c0 .15-.185.391-.45.494a6.409 6.409 0 0 0-.277.115.85.85 0 0 1-.337.07c-.141 0-.269-.04-.331-.102l-.43-.43a1.365 1.365 0 0 0-.973-.404 1.36 1.36 0 0 0-.97.404l-.72.719a1.375 1.375 0 0 0 0 1.942l.43.431c.108.107.147.408.032.668a6.43 6.43 0 0 0-.114.277c-.103.265-.343.45-.495.45h-.61A1.374 1.374 0 0 0 0 7.99v1.018c0 .757.616 1.374 1.374 1.374h.609c.152 0 .392.184.494.449.036.093.075.186.115.277.115.26.075.56-.032.668l-.43.43a1.376 1.376 0 0 0 0 1.944l.72.72c.259.26.604.402.97.402.367 0 .712-.143.972-.402l.43-.431c.064-.064.188-.102.332-.102a.85.85 0 0 1 .336.07c.09.04.184.078.278.115.265.102.45.343.45.494v.61c0 .757.616 1.373 1.373 1.373h1.018c.757 0 1.374-.616 1.374-1.374v-.609c0-.151.184-.392.449-.494a6.31 6.31 0 0 0 .277-.115.85.85 0 0 1 .336-.07c.142 0 .27.04.332.102l.43.43a1.368 1.368 0 0 0 1.092.398c.502-.044.944-.488 1.182-.727l.03-.03.36-.36a1.378 1.378 0 0 0 0-1.943l-.43-.431c-.108-.107-.148-.408-.033-.668.04-.091.08-.184.115-.277.102-.265.343-.45.494-.45h.61c.757 0 1.373-.616 1.373-1.373V7.99c0-.757-.616-1.374-1.373-1.374zM12.217 8.5A3.72 3.72 0 0 1 8.5 12.217 3.72 3.72 0 0 1 4.783 8.5 3.721 3.721 0 0 1 8.5 4.783 3.72 3.72 0 0 1 12.217 8.5z" />
    </svg>
  );
};

export const Head = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="23" viewBox="0 0 25 23">
      <path d="M18.514 13.415C22.38 14.293 25 15.989 25 17.92v2.012C25 21.628 23.602 23 21.875 23H3.125C1.398 23 0 21.628 0 19.933v-2.02c0-1.932 2.62-3.623 6.485-4.5a6.991 6.991 0 0 0 5.69 2.922h.65a6.991 6.991 0 0 0 5.69-2.92zM12.285 0h.43a5.143 5.143 0 0 1 5.142 5.142v3.516a5.143 5.143 0 0 1-5.142 5.142h-.43a5.143 5.143 0 0 1-5.142-5.142V5.142A5.143 5.143 0 0 1 12.285 0z" />
    </svg>
  );
};

export const Tag = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
      <path d="M61.007 11.636l53.652 53.656c1.482 1.48 1.703 3.213 1.703 4.113 0 .9-.22 2.63-1.705 4.114l-41.14 41.14c-1.485 1.482-3.216 1.703-4.115 1.703-.9 0-2.633-.22-4.115-1.705L11.636 61.004v-49.37h49.37zM65.825 0H0v65.825l57.062 57.062c3.41 3.408 7.876 5.113 12.343 5.113 4.466 0 8.934-1.705 12.342-5.113l41.14-41.14c6.816-6.818 6.816-17.868 0-24.685L65.825 0zm-22.19 29.09c-8.032 0-14.544 6.514-14.544 14.546s6.514 14.546 14.547 14.546c8.032 0 14.546-6.514 14.546-14.546S51.67 29.09 43.636 29.09zm0 17.455c-1.604 0-2.908-1.303-2.908-2.91 0-1.604 1.304-2.908 2.91-2.908 1.605 0 2.908 1.304 2.908 2.91 0 1.605-1.3 2.908-2.91 2.908z" />
    </svg>
  );
};

export const Memory = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21">
      <path
        fill="#6E848B"
        d="M22.185 11.187c0-1.09-.692-2.02-1.63-2.425.367-.364.612-.89.612-1.456 0-1.132-.937-2.06-2.078-2.06h-.21c.12-.284.2-.608.2-.93 0-1.133-.938-2.063-2.08-2.063-.366 0-.69.08-.977.243C15.75 1.686 14.973 1 14.08 1 12.938 1 12.04 2.05 12 2.86v14.15h.04c0 1.454 1.182 2.586 2.65 2.586 1.303 0 2.362-.93 2.606-2.143.245.08.53.12.815.12 1.47 0 2.65-1.17 2.65-2.626 0-.445-.12-.89-.32-1.294.98-.323 1.75-1.293 1.75-2.466zM1 11.187c0-1.09.693-2.02 1.63-2.425-.367-.364-.61-.89-.61-1.456 0-1.132.936-2.06 2.076-2.06H4.3c-.122-.284-.204-.608-.204-.93 0-1.133.937-2.063 2.078-2.063.367 0 .693.08.978.243C7.437 1.686 8.212 1 9.107 1c1.14 0 2.037 1.05 2.078 1.86v14.15h-.04c0 1.454-1.182 2.586-2.65 2.586-1.302 0-2.362-.93-2.606-2.143-.25.08-.53.12-.82.12-1.47 0-2.65-1.17-2.65-2.626 0-.445.12-.89.323-1.294C1.773 13.33 1 12.36 1 11.187z"
      />
      <path
        stroke="#F5F6F6"
        d="M22.185 11.187c0-1.09-.692-2.02-1.63-2.425.367-.364.612-.89.612-1.456 0-1.132-.937-2.06-2.078-2.06h-.21c.12-.284.2-.608.2-.93 0-1.133-.938-2.063-2.08-2.063-.366 0-.69.08-.977.243C15.75 1.686 14.973 1 14.08 1 12.938 1 12.04 2.05 12 2.86v14.15h.04c0 1.454 1.182 2.586 2.65 2.586 1.303 0 2.362-.93 2.606-2.143.245.08.53.12.815.12 1.47 0 2.65-1.17 2.65-2.626 0-.445-.12-.89-.32-1.294.98-.323 1.75-1.293 1.75-2.466zM1 11.187c0-1.09.693-2.02 1.63-2.425-.367-.364-.61-.89-.61-1.456 0-1.132.936-2.06 2.076-2.06H4.3c-.122-.284-.204-.608-.204-.93 0-1.133.937-2.063 2.078-2.063.367 0 .693.08.978.243C7.437 1.686 8.212 1 9.107 1c1.14 0 2.037 1.05 2.078 1.86v14.15h-.04c0 1.454-1.182 2.586-2.65 2.586-1.302 0-2.362-.93-2.606-2.143-.25.08-.53.12-.82.12-1.47 0-2.65-1.17-2.65-2.626 0-.445.12-.89.323-1.294C1.773 13.33 1 12.36 1 11.187z"
      />
      <path
        stroke="#F5F6F6"
        d="M5 12.016s1.874-.283 2.69 1.536c.895 2.02-.286 3.517-2.038 4.083m3.4-11.948S8.032 7.304 6.2 6.9C4.367 6.496 4 5 4 5m5.648 4.345C9.608 9.305 9.118 7.605 7 7m9.073 3s-.49 1.78 1.06 3.153c.733.647 2.2.85 3.462.687M15 6.253s1.1.687 2.037.404C17.974 6.374 18.627 5 18.627 5M14 15.062S14.53 13 16.974 13"
      />
    </svg>
  );
};

export const Company = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
      <path d="M8 8c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3zm3 5c-4.6 0-6 3.3-6 3.3V18h12v-1.7S15.6 13 11 13z" />
      <g transform="translate(14 5)">
        <circle cx="3.5" cy="2.5" r="2.5" />
        <path d="M3.5 7c-1.2 0-2.1.3-2.8.8 2.3 1.1 3.2 3 3.2 3.2v.1H8V9.8C8 9.7 6.9 7 3.5 7z" />
      </g>
      <g transform="translate(14 5)">
        <circle cx="3.5" cy="2.5" r="2.5" />
        <path d="M3.5 7c-1.2 0-2.1.3-2.8.8 2.3 1.1 3.2 3 3.2 3.2v.1H8V9.8C8 9.7 6.9 7 3.5 7z" />
      </g>
      <g transform="translate(0 5)">
        <circle cx="4.5" cy="2.5" r="2.5" />
        <path d="M4.5 7c1.2 0 2.1.3 2.8.8-2.3 1.1-3.2 3-3.2 3.2v.1H0V9.8C0 9.7 1.1 7 4.5 7z" />
      </g>
    </svg>
  );
};

export const Solo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22">
      <g transform="translate(0 5)">
        <ellipse cx="6" cy="3" rx="3" ry="3" />
        <path d="M6 7.5c-4.575 0-6 3-6 3V12h12v-1.5s-1.425-3-6-3z" />
      </g>
    </svg>
  );
};

export const Brain = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-testid="brain_icon"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="currentColor"
      {...props}
    >
      <path d="M14.242 13.657l.022.02c.732.658 2.1.924 3.438.772.012.1.02.2.02.3 0 1.33-1.06 2.4-2.376 2.4-.256 0-.51-.04-.73-.11-.22 1.11-1.17 1.96-2.34 1.96-1.314 0-2.374-1.04-2.374-2.37h-.037V3.7c.037-.74.84-1.7 1.864-1.7.8 0 1.49.628 1.75 1.367.25-.147.55-.22.87-.22 1.02 0 1.86.85 1.86 1.883 0 .15-.02.3-.05.443l-.04.07c-.11.19-.23.377-.37.55-.278.348-.56.584-.82.664-.084.024-.17.04-.264.046-.3.02-.643-.06-.99-.205-.11-.047-.216-.097-.308-.147-.055-.02-.09-.05-.105-.05l-.54.89c.03.02.09.057.16.098.12.066.255.13.4.19.48.2.967.31 1.445.28.17-.01.33-.04.49-.09.495-.15.93-.51 1.32-1.01.17-.215.32-.444.45-.673L17 6.07c.628.303 1.067.954 1.067 1.7 0 .517-.22.997-.55 1.33.84.37 1.462 1.22 1.462 2.217 0 1.023-.64 1.878-1.46 2.21-1.09.113-2.18-.103-2.677-.547-.217-.2-.39-.41-.525-.64-.344-.574-.416-1.187-.334-1.723.01-.065.02-.107.022-.12l-.89-.25c-.01.05-.03.124-.043.225-.11.73-.015 1.552.446 2.336-.705.164-1.266.53-1.69 1.037-.207.244-.366.51-.48.77-.075.162-.12.293-.14.38l.89.233.014-.045c.02-.054.04-.11.07-.178.087-.19.2-.38.348-.555.39-.466.93-.757 1.677-.797zm-9.177-5.74c-.233.007-.475-.017-.725-.073-.744-.167-1.328-.52-1.762-1.003-.22-.24-.39-.51-.51-.77l-.018-.04c-.667.29-1.14.96-1.14 1.74 0 .52.22 1 .55 1.33C.622 9.47 0 10.32 0 11.32c0 1.07.694 1.96 1.57 2.253-.182.37-.29.776-.29 1.183 0 1.33 1.058 2.406 2.374 2.406.218 0 .437-.028.633-.08 1.368-.577 1.937-1.75 1.326-3.155-.207-.472-.505-.786-.876-.98-.378-.196-.783-.25-1.118-.22l-.04.004-.14-.95c.02 0 .05-.01.1-.01.49-.04 1.07.03 1.62.32.56.29 1.01.77 1.31 1.45.83 1.91.02 3.6-1.74 4.39.43.64 1.16 1.07 1.99 1.07 1.31 0 2.37-1.03 2.37-2.36h.036V3.7C9.1 2.96 8.294 2 7.27 2c-.803 0-1.497.628-1.753 1.367-.255-.147-.548-.22-.877-.22-1.023 0-1.863.85-1.863 1.883 0 .143.017.285.047.424l.01-.003c.008.03.033.11.08.21.085.19.2.37.355.54.3.34.72.59 1.27.72.66.15 1.23-.03 1.72-.45.13-.11.25-.23.34-.35.05-.07.09-.12.1-.14l.79.51c-.035.057-.09.14-.175.24-.133.167-.29.33-.47.48-.138.12-.28.22-.43.31.3.19.57.41.803.65.28.3.5.61.667.94.06.11.107.21.15.316l.035.087c-.023-.046-.038-.07-.088-.123l-.66.676c-.077-.08-.227-.44-.265-.51-.128-.25-.295-.49-.51-.72-.38-.4-.874-.71-1.5-.892l.003-.01z" />
    </svg>
  );
};

export const NoBrain = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-testid="no_brain_icon"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="currentColor"
      {...props}
    >
      <path d="M14.242 13.657l.022.02c.732.658 2.1.924 3.438.772.012.1.02.2.02.3 0 1.33-1.06 2.4-2.376 2.4-.256 0-.51-.04-.73-.11-.22 1.11-1.17 1.96-2.34 1.96-1.314 0-2.374-1.04-2.374-2.37h-.037V3.7c.037-.74.84-1.7 1.864-1.7.8 0 1.49.628 1.75 1.367.25-.147.55-.22.87-.22 1.02 0 1.86.85 1.86 1.883 0 .15-.02.3-.05.443l-.04.07c-.11.19-.23.377-.37.55-.278.348-.56.584-.82.664-.084.024-.17.04-.264.046-.3.02-.643-.06-.99-.205-.11-.047-.216-.097-.308-.147-.055-.02-.09-.05-.105-.05l-.54.89c.03.02.09.057.16.098.12.066.255.13.4.19.48.2.967.31 1.445.28.17-.01.33-.04.49-.09.495-.15.93-.51 1.32-1.01.17-.215.32-.444.45-.673L17 6.07c.628.303 1.067.954 1.067 1.7 0 .517-.22.997-.55 1.33.84.37 1.462 1.22 1.462 2.217 0 1.023-.64 1.878-1.46 2.21-1.09.113-2.18-.103-2.677-.547-.217-.2-.39-.41-.525-.64-.344-.574-.416-1.187-.334-1.723.01-.065.02-.107.022-.12l-.89-.25c-.01.05-.03.124-.043.225-.11.73-.015 1.552.446 2.336-.705.164-1.266.53-1.69 1.037-.207.244-.366.51-.48.77-.075.162-.12.293-.14.38l.89.233.014-.045c.02-.054.04-.11.07-.178.087-.19.2-.38.348-.555.39-.466.93-.757 1.677-.797zm-9.177-5.74c-.233.007-.475-.017-.725-.073-.744-.167-1.328-.52-1.762-1.003-.22-.24-.39-.51-.51-.77l-.018-.04c-.667.29-1.14.96-1.14 1.74 0 .52.22 1 .55 1.33C.622 9.47 0 10.32 0 11.32c0 1.07.694 1.96 1.57 2.253-.182.37-.29.776-.29 1.183 0 1.33 1.058 2.406 2.374 2.406.218 0 .437-.028.633-.08 1.368-.577 1.937-1.75 1.326-3.155-.207-.472-.505-.786-.876-.98-.378-.196-.783-.25-1.118-.22l-.04.004-.14-.95c.02 0 .05-.01.1-.01.49-.04 1.07.03 1.62.32.56.29 1.01.77 1.31 1.45.83 1.91.02 3.6-1.74 4.39.43.64 1.16 1.07 1.99 1.07 1.31 0 2.37-1.03 2.37-2.36h.036V3.7C9.1 2.96 8.294 2 7.27 2c-.803 0-1.497.628-1.753 1.367-.255-.147-.548-.22-.877-.22-1.023 0-1.863.85-1.863 1.883 0 .143.017.285.047.424l.01-.003c.008.03.033.11.08.21.085.19.2.37.355.54.3.34.72.59 1.27.72.66.15 1.23-.03 1.72-.45.13-.11.25-.23.34-.35.05-.07.09-.12.1-.14l.79.51c-.035.057-.09.14-.175.24-.133.167-.29.33-.47.48-.138.12-.28.22-.43.31.3.19.57.41.803.65.28.3.5.61.667.94.06.11.107.21.15.316l.035.087c-.023-.046-.038-.07-.088-.123l-.66.676c-.077-.08-.227-.44-.265-.51-.128-.25-.295-.49-.51-.72-.38-.4-.874-.71-1.5-.892l.003-.01z" />
      <line x1="1" y1="1" x2="18" y2="21" stroke="white" strokeWidth="4" />
      <line x1="1" y1="1" x2="18" y2="21" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};

export const Calendar = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 16 22">
      <path d="M12.622 2h-1.245v3.022h1.245V2zm-8 0H3.38v3.022h1.245V2zm9.6 14.223H1.778V9.11h12.444v7.113zm0-12.446h-.8v1.78h-2.844v-1.78H5.422v1.78H2.578v-1.78h-.8C.8 3.777 0 4.577 0 5.557v10.666C0 17.2.8 18 1.778 18h12.444C15.2 18 16 17.2 16 16.223V5.556c0-.978-.8-1.78-1.778-1.78z" />
    </svg>
  );
};

export const Ellipsis = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-testid="ellipsis-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="5"
      viewBox="0 0 20 5"
      {...props}
    >
      <circle cx="17.5" cy="2.5" r="2.5" />
      <circle cx="10" cy="2.5" r="2.5" />
      <circle cx="2.5" cy="2.5" r="2.5" />
    </svg>
  );
};

export const DownloadSymbol: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path d="M10.5972 6.47429C10.5375 6.41457 10.4667 6.3672 10.3888 6.33488C10.3108 6.30256 10.2273 6.28592 10.1429 6.28592C10.0585 6.28592 9.97493 6.30256 9.89698 6.33488C9.81903 6.3672 9.74821 6.41457 9.68859 6.47429L8.64287 7.51914V2.64286C8.64287 2.47236 8.57514 2.30885 8.45458 2.18829C8.33403 2.06773 8.17051 2 8.00002 2C7.82952 2 7.66601 2.06773 7.54545 2.18829C7.42489 2.30885 7.35716 2.47236 7.35716 2.64286V7.51914L6.31144 6.47429C6.25259 6.41113 6.18162 6.36047 6.10276 6.32533C6.02391 6.29019 5.93878 6.2713 5.85246 6.26978C5.76615 6.26826 5.68041 6.28413 5.60036 6.31647C5.52031 6.3488 5.4476 6.39692 5.38655 6.45797C5.32551 6.51901 5.27739 6.59173 5.24505 6.67177C5.21272 6.75182 5.19684 6.83756 5.19837 6.92388C5.19989 7.01019 5.21878 7.09532 5.25392 7.17418C5.28905 7.25303 5.33971 7.324 5.40287 7.38286L7.54573 9.52571C7.60536 9.58543 7.67617 9.6328 7.75412 9.66512C7.83207 9.69744 7.91563 9.71407 8.00002 9.71407C8.0844 9.71407 8.16796 9.69744 8.24591 9.66512C8.32386 9.6328 8.39467 9.58543 8.4543 9.52571L10.5972 7.38286C10.6569 7.32323 10.7042 7.25242 10.7366 7.17447C10.7689 7.09651 10.7855 7.01296 10.7855 6.92857C10.7855 6.84419 10.7689 6.76063 10.7366 6.68268C10.7042 6.60473 10.6569 6.53391 10.5972 6.47429V6.47429Z" />
      <path d="M13.1429 10.1428C12.9155 10.1428 12.6975 10.2332 12.5368 10.3939C12.376 10.5546 12.2857 10.7727 12.2857 11V12.0714C12.2857 12.1283 12.2631 12.1828 12.223 12.2229C12.1828 12.2631 12.1283 12.2857 12.0714 12.2857H3.92857C3.87174 12.2857 3.81723 12.2631 3.77705 12.2229C3.73686 12.1828 3.71429 12.1283 3.71429 12.0714V11C3.71429 10.7727 3.62398 10.5546 3.46323 10.3939C3.30249 10.2332 3.08447 10.1428 2.85714 10.1428C2.62981 10.1428 2.4118 10.2332 2.25105 10.3939C2.09031 10.5546 2 10.7727 2 11V12.2857C2 12.7404 2.18061 13.1764 2.5021 13.4979C2.82359 13.8194 3.25963 14 3.71429 14H12.2857C12.7404 14 13.1764 13.8194 13.4979 13.4979C13.8194 13.1764 14 12.7404 14 12.2857V11C14 10.7727 13.9097 10.5546 13.7489 10.3939C13.5882 10.2332 13.3702 10.1428 13.1429 10.1428Z" />
    </svg>
  );
};

export const Close: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" {...props}>
      <path d="M8.237 7l5.507-5.506c.34-.342.34-.896 0-1.238-.342-.34-.896-.34-1.238 0L7 5.762 1.494.256c-.342-.34-.896-.34-1.238 0-.34.342-.34.896 0 1.238L5.763 7 .256 12.506c-.34.342-.34.896 0 1.238.17.17.395.256.62.256.223 0 .447-.086.618-.256L7 8.237l5.506 5.507c.17.17.395.256.62.256.223 0 .447-.086.618-.256.34-.342.34-.896 0-1.238L8.237 7z" />
    </svg>
  );
};

export const CloseSolid = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" {...props}>
      <path d="M9.47108 1.47145C9.73143 1.2111 9.73143 0.788986 9.47108 0.528636C9.21073 0.268287 8.78862 0.268287 8.52827 0.528636L4.99967 4.05723L1.47108 0.528636C1.21073 0.268287 0.788619 0.268287 0.52827 0.528636C0.26792 0.788986 0.26792 1.2111 0.52827 1.47145L4.05687 5.00004L0.52827 8.52864C0.26792 8.78899 0.26792 9.2111 0.52827 9.47145C0.788619 9.7318 1.21073 9.7318 1.47108 9.47145L4.99967 5.94285L8.52827 9.47145C8.78862 9.7318 9.21073 9.7318 9.47108 9.47145C9.73143 9.2111 9.73143 8.78899 9.47108 8.52864L5.94248 5.00004L9.47108 1.47145Z" />
    </svg>
  );
};

export const Lock: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg width="11" height="13" viewBox="0 0 11 13" {...props}>
      <path
        fill={props.fill || 'currentColor'}
        fillRule="evenodd"
        d="M3.93 3.212c0-1.106.625-1.683 1.57-1.683.945 0 1.572.574 1.572 1.68v1.376H3.93V3.212zm6.127 1.376H8.643v-1.07C8.643 1.303 7.595 0 5.5 0 3.406 0 2.358 1.303 2.358 3.518v1.07H.786c-.434 0-.786.496-.786.92v5.963c0 .42.337.874.748 1l.94.298c.412.13 1.1.234 1.534.234H7.78c.43 0 1.12-.104 1.532-.233l.94-.296c.41-.128.748-.58.748-1V5.508c0-.423-.51-.92-.943-.92z"
      />
    </svg>
  );
};

export const Refresh = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="1285 123 21 20">
      <path d="M1306 124.9v5.7c0 .525-.448.95-1 .95h-6c-.552 0-1-.425-1-.95 0-.525.448-.95 1-.95h3.372c-1.356-1.256-2.054-2.14-2.715-2.524-.742-.34-.654-.288-1.646-.67-.954-.37-1.97-.556-3.01-.556-1.04 0-2.05.187-3.01.556-.99.382-1.88.944-2.644 1.67s-1.355 1.57-1.757 2.514c-.39.91-.587 1.872-.587 2.86 0 .988.198 1.95.587 2.86.4.943.992 1.788 1.756 2.514.764.726 1.654 1.288 2.646 1.67.957.37 1.97.556 3.01.556 1.04 0 2.053-.187 3.01-.556.993-.382 1.883-.944 2.647-1.67.43-.408.806-.86 1.126-1.343.31-.47.565-.97.76-1.493.183-.495.755-.754 1.275-.58.52.175.795.717.61 1.212-.242.655-.562 1.285-.95 1.873-.4.606-.872 1.17-1.41 1.68-.952.905-2.065 1.607-3.306 2.085-.597.23-1.22.406-1.854.522-.63.115-1.27.173-1.91.173-.64 0-1.282-.057-1.91-.173-.632-.116-1.256-.292-1.852-.522-1.242-.478-2.355-1.18-3.31-2.086-.953-.908-1.693-1.965-2.196-3.145-.24-.566-.425-1.16-.55-1.76-.12-.596-.18-1.206-.18-1.814 0-.607.06-1.217.182-1.813.122-.6.307-1.194.55-1.76.503-1.18 1.242-2.237 2.196-3.143.953-.907 2.066-1.61 3.307-2.087.597-.23 1.22-.406 1.853-.522.628-.116 1.27-.174 1.91-.174.64 0 1.282.06 1.91.175.632.114 1.256.29 1.852.52 1.242.48 1.584.6 2.31 1.086.517.422 1.467 1.37 2.928 2.722v-3.61c0-.525.448-.95 1-.95s1 .425 1 .95z" />
    </svg>
  );
};

export const Help = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
      <path
        fillRule="evenodd"
        d="M9.5 19C4.253 19 0 14.747 0 9.5S4.253 0 9.5 0 19 4.253 19 9.5 14.747 19 9.5 19zm0-2c4.142 0 7.5-3.358 7.5-7.5C17 5.358 13.642 2 9.5 2 5.358 2 2 5.358 2 9.5 2 13.642 5.358 17 9.5 17zm2.587-9.478c0 .23-.028.43-.083.603-.055.173-.133.332-.234.478-.1.145-.222.282-.364.41-.142.13-.303.262-.483.4-.11.09-.203.17-.276.24-.072.07-.13.14-.17.213-.043.073-.072.15-.09.23-.017.078-.025.174-.025.284v.27H8.74v-.394c0-.18.017-.342.052-.484.035-.142.087-.272.156-.39.07-.117.154-.232.255-.342.1-.11.22-.226.358-.344l.346-.322c.118-.104.22-.213.302-.327.083-.115.124-.25.124-.41 0-.223-.066-.4-.2-.53-.136-.133-.32-.198-.557-.198-.29 0-.51.095-.655.293-.146.197-.226.42-.24.67L7.026 7.7c.04-.376.137-.705.286-.99.15-.283.342-.52.578-.706.235-.187.502-.327.8-.42.298-.094.613-.14.946-.14.312 0 .615.04.91.118.294.08.556.205.784.375.23.17.413.386.55.65.14.263.21.574.21.935zm-1.517 4.594c0 .278-.098.512-.292.702-.194.19-.433.286-.717.286-.135 0-.265-.024-.39-.073-.12-.045-.225-.115-.32-.205-.092-.09-.17-.194-.222-.312-.056-.116-.084-.245-.084-.383 0-.133.026-.26.078-.38.053-.12.126-.228.22-.318.093-.09.2-.16.327-.213.124-.054.256-.08.394-.08.14 0 .27.025.39.077.122.052.23.122.323.208.094.087.167.19.22.312.05.12.077.248.077.38z"
      />
    </svg>
  );
};

export const Checkmark = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" {...props}>
    <path d="M5.42341 12.7144C5.16532 12.7109 4.91139 12.6488 4.68079 12.5329C4.4502 12.4169 4.24896 12.2501 4.09227 12.0449L2.21255 9.90808C2.07401 9.73607 2.00722 9.51723 2.02609 9.29718C2.04496 9.07713 2.14804 8.87285 2.31384 8.72694C2.47964 8.58104 2.69537 8.50476 2.91603 8.51402C3.1367 8.52328 3.34527 8.61737 3.49827 8.77665L5.2597 10.7815C5.27929 10.8038 5.30329 10.8217 5.33018 10.8342C5.35707 10.8467 5.38626 10.8535 5.41591 10.8542C5.44556 10.8548 5.47502 10.8493 5.50242 10.838C5.52983 10.8266 5.55459 10.8098 5.57513 10.7884L12.518 3.55236C12.5955 3.47076 12.6884 3.40522 12.7913 3.35951C12.8942 3.31379 13.005 3.28879 13.1176 3.28592C13.2301 3.28306 13.3421 3.30239 13.4472 3.34281C13.5523 3.38323 13.6484 3.44395 13.73 3.52151C13.8116 3.59906 13.8771 3.69193 13.9228 3.79481C13.9686 3.89769 13.9936 4.00857 13.9964 4.12112C13.9993 4.23366 13.98 4.34567 13.9395 4.45074C13.8991 4.55582 13.8384 4.6519 13.7608 4.73351L6.73055 12.1332C6.56961 12.3212 6.36876 12.4709 6.14263 12.5715C5.9165 12.672 5.6708 12.7208 5.42341 12.7144Z" />
  </svg>
);

export const Clipboard = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="72" height="88" viewBox="0 0 72 88" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M60 8h-4.697C53.653 3.342 49.223 0 44 0H28c-5.223 0-9.652 3.342-11.303 8H12C5.37 8 0 13.37 0 20v56c0 6.63 5.37 12 12 12h48c6.63 0 12-5.37 12-12V20c0-6.63-5.37-12-12-12zM28 8h16c2.21 0 4 1.79 4 4s-1.79 4-4 4H28c-2.21 0-4-1.79-4-4s1.79-4 4-4zm36 68c0 2.21-1.79 4-4 4H12c-2.21 0-4-1.79-4-4V20c0-2.21 1.79-4 4-4h4.697c1.648 4.658 6.08 8 11.303 8h16c5.223 0 9.652-3.342 11.303-8H60c2.21 0 4 1.79 4 4v56z" />
    </svg>
  );
};

export const Grid = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
      <g fill="none" fillRule="evenodd" strokeWidth="2">
        <rect width="8" height="8" x="1" y="1" rx="1" />
        <rect width="8" height="8" x="16" y="1" rx="1" />
        <rect width="8" height="8" x="16" y="16" rx="1" />
        <rect width="8" height="8" x="1" y="16" rx="1" />
      </g>
    </svg>
  );
};

export const Globe = () => {
  return (
    <svg width="88" height="88" viewBox="0 0 88 88" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M45.69.03C45.13.01 44.57 0 44 0c-.57 0-1.13.01-1.69.03C18.79.92 0 20.27 0 44s18.79 43.08 42.31 43.97c.56.02 1.12.03 1.69.03.57 0 1.13-.01 1.69-.03C69.21 87.08 88 67.73 88 44S69.21.92 45.69.03zM79.77 40H63.86c-.91-13.4-6.27-24.09-10.74-30.84C67.33 12.88 78.13 25.06 79.77 40zM44.01 10.18c3.93 5.12 10.7 15.8 11.83 29.82H32.16c1.13-13.96 7.92-24.68 11.85-29.82zM55.84 48c-1.13 13.96-7.91 24.68-11.85 29.82-3.93-5.12-10.7-15.8-11.83-29.82h23.68zM34.88 9.16C30.41 15.91 25.05 26.6 24.14 40H8.23C9.87 25.06 20.67 12.88 34.88 9.16zM8.23 48h15.91c.91 13.39 6.26 24.08 10.73 30.83C20.66 75.12 9.87 62.94 8.23 48zm44.9 30.83C57.6 72.08 62.95 61.39 63.86 48h15.91c-1.64 14.94-12.43 27.12-26.64 30.83z"
        fillRule="nonzero"
      />
    </svg>
  );
};

export const Box = () => {
  return (
    <svg width="88" height="96" viewBox="0 0 88 96" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44 0L0 20v56l44 20 44-20V20L44 0zm0 8.79L73.5 22.2 44 35.61 14.49 22.2 44 8.79zM8 70.85V28.03l32 14.54v42.82L8 70.85zm72 0L48 85.39V42.57l32-14.54v42.82z"
        fillRule="nonzero"
      />
    </svg>
  );
};

export const Layers = () => {
  return (
    <svg width="96" height="82" viewBox="0 0 96 82" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M48 73.016l-39-19.5-9 4.5 48 24 48-24-9-4.5-39 19.5zm0-16.985L9 36.53l-9 4.5 48 24 48-24-9-4.5-39 19.5zM96 24L48 0 0 24l48 24 48-24zM48 8.943L78.11 24 48 39.057 17.89 24 48 8.943z"
        fillRule="nonzero"
      />
    </svg>
  );
};

export const Bell = () => {
  return (
    <svg width="96" height="88" viewBox="0 0 96 88" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M96 72c-8-8-12-20-16-40C76.534 14.673 65.67 0 48 0S19.465 14.673 16 32C12 52 8 64 0 72h36.697c-.443 1.253-.697 2.596-.697 4 0 6.627 5.373 12 12 12s12-5.373 12-12c0-1.404-.254-2.747-.697-4H96zM23.845 33.568C25.045 27.57 30.332 8 48 8s22.956 19.57 24.155 25.568c2.48 12.4 5.03 22.343 8.823 30.432H15.02c3.794-8.09 6.345-18.033 8.825-30.432zM52 76c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4z"
        fillRule="nonzero"
      />
    </svg>
  );
};

export const Billed = () => {
  return (
    <svg
      data-testid="billed-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path d="M9 0C4.03 0 0 4.03 0 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16.36c-4.07 0-7.36-3.3-7.36-7.36S4.94 1.64 9 1.64s7.36 3.3 7.36 7.36-3.3 7.36-7.36 7.36zm2.17-9.58l-2.9 2.9-1.14-1.16c-.32-.32-.84-.32-1.16 0-.32.32-.32.84 0 1.16L7.7 11.4c.32.33.84.33 1.16 0l3.47-3.46c.32-.32.32-.84 0-1.16-.32-.32-.84-.32-1.16 0z" />
    </svg>
  );
};

export const Heart = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94 81">
      <path d="M86.598 7.463c-9.373-9.373-24.568-9.373-33.939 0L47 13.12l-5.658-5.655c-9.373-9.373-24.568-9.373-33.939 0-9.373 9.372-9.373 24.567 0 33.94l5.656 5.654L47 81l33.941-33.941 5.656-5.654c9.374-9.373 9.374-24.569.001-33.942zM69.627 47.061L47 69.688 24.373 47.061 13.061 35.749c-6.248-6.248-6.248-16.379 0-22.629 6.25-6.248 16.379-6.248 22.627 0L47 24.434 58.314 13.12c6.248-6.248 16.379-6.248 22.627 0 6.248 6.25 6.248 16.379 0 22.629L69.627 47.061z" />
    </svg>
  );
};

export const File = () => {
  return (
    <svg
      stroke="#000"
      width="20"
      height="24"
      viewBox="0 0 10 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        strokeWidth="1.2"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5.5 1H2c-.552 0-1 .448-1 1v8c0 .552.448 1 1 1h6c.552 0 1-.448 1-1V4.5L5.5 1z" />
        <path d="M5.5 1v3.5H9" />
      </g>
    </svg>
  );
};

export const Reject = () => (
  <svg viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.694.306c-.408-.408-1.07-.408-1.478 0L4 2.522 1.784.306C1.376-.102.714-.102.306.306c-.408.408-.408 1.07 0 1.478L2.522 4 .306 6.216c-.408.408-.408 1.07 0 1.478.408.408 1.07.408 1.478 0L4 5.478l2.216 2.216c.408.408 1.07.408 1.478 0 .408-.408.408-1.07 0-1.478L5.478 4l2.216-2.216c.408-.408.408-1.07 0-1.478z" />
  </svg>
);

export const Wand = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.75 5.46a.52.52 0 0 0-.153-.385l-1.691-1.69a.521.521 0 0 0-.385-.154.521.521 0 0 0-.384.153L1.154 14.368a.521.521 0 0 0-.154.384.52.52 0 0 0 .154.384l1.69 1.691a.522.522 0 0 0 .385.154.52.52 0 0 0 .385-.154L14.597 5.844a.522.522 0 0 0 .153-.384zm-3.817 2.502l-.914-.914 2.502-2.502.914.914-2.502 2.502zM1.5 3l-.352-1.148L0 1.5l1.148-.352L1.5 0l.352 1.148L3 1.5l-1.148.352L1.5 3zm3.18 2.32L2 4.5l2.68-.82L5.5 1l.82 2.68L9 4.5l-2.68.82L5.5 8l-.82-2.68zm9.234 4.766L12 9.5l1.914-.586L14.5 7l.586 1.914L17 9.5l-1.914.586L14.5 12l-.586-1.914zm-2.063 3.062L13 13.5l-1.149.352L11.5 15l-.352-1.148L10 13.5l1.148-.352L11.5 12l.351 1.148zM9.5 3l-.351-1.148L8 1.5l1.149-.352L9.5 0l.352 1.148L11 1.5l-1.148.352L9.5 3z" />
  </svg>
);

export const Pin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 88" {...props}>
    <path
      fillRule="nonzero"
      fill="currentColor"
      d="M62.916 11.178a4.003 4.003 0 0 0-5.656-.016 4.015 4.015 0 0 0-.9 1.42c-3.328 6.944-6.992 10.86-11.616 13.172-5.188 2.56-11.144 4.34-20.744 4.34-.52 0-1.04.1-1.528.304a4.024 4.024 0 0 0-2.164 2.164 4.004 4.004 0 0 0 0 3.056c.204.492.496.936.868 1.304l9.497 10.079L16 74.094l27.135-14.48 10.033 9.3a3.9 3.9 0 0 0 1.304.868 3.969 3.969 0 0 0 1.528.312c.52 0 1.04-.108 1.528-.312a3.985 3.985 0 0 0 2.164-2.164A3.945 3.945 0 0 0 60 66.094c0-9.6 1.776-15.556 4.332-20.664 2.308-4.624 6.224-8.288 13.172-11.616a3.93 3.93 0 0 0 1.416-.9 4.003 4.003 0 0 0-.016-5.656l-15.988-16.08z"
    />
  </svg>
);

export const Unpin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 96 88"
    {...props}
  >
    <defs>
      <rect id="a" width="6" height="60" x="62.654" y="21.987" rx="3" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M62.916 11.178a4.003 4.003 0 0 0-5.656-.016 4.015 4.015 0 0 0-.9 1.42c-3.328 6.944-6.992 10.86-11.616 13.172-5.188 2.56-11.144 4.34-20.744 4.34-.52 0-1.04.1-1.528.304a4.024 4.024 0 0 0-2.164 2.164 4.004 4.004 0 0 0 0 3.056c.204.492.496.936.868 1.304l9.497 10.079L16 74.094l27.135-14.48 10.033 9.3a3.9 3.9 0 0 0 1.304.868 3.969 3.969 0 0 0 1.528.312c.52 0 1.04-.108 1.528-.312a3.985 3.985 0 0 0 2.164-2.164A3.945 3.945 0 0 0 60 66.094c0-9.6 1.776-15.556 4.332-20.664 2.308-4.624 6.224-8.288 13.172-11.616a3.93 3.93 0 0 0 1.416-.9 4.003 4.003 0 0 0-.016-5.656l-15.988-16.08z"
      />
      <g transform="rotate(-44 39.116 57.1)">
        <use fill="currentColor" xlinkHref="#a" />
        <rect width="9" height="63" x="61.154" y="20.487" stroke="#FFF" strokeWidth="3" rx="4.5" />
      </g>
    </g>
  </svg>
);

export const GooglePlayBadge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 135 40">
    <path d="M130 40H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5h125c2.8 0 5 2.2 5 5v30c0 2.8-2.2 5-5 5z" />
    <path
      d="M130 .8c2.3 0 4.2 1.9 4.2 4.2v30c0 2.3-1.9 4.2-4.2 4.2H5C2.7 39.2.8 37.3.8 35V5C.8 2.7 2.7.8 5 .8h125m0-.8H5C2.2 0 0 2.3 0 5v30c0 2.8 2.2 5 5 5h125c2.8 0 5-2.2 5-5V5c0-2.7-2.2-5-5-5z"
      fill="#a6a6a6"
    />
    <path
      d="M47.4 10.2c0 .8-.2 1.5-.7 2-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2 0-.9.3-1.6.9-2.2a2.94 2.94 0 0 1 3.4-.6c.4.2.7.4.9.7l-.5.5c-.4-.5-.9-.7-1.6-.7-.6 0-1.2.2-1.6.7-.5.4-.7 1-.7 1.7s.2 1.3.7 1.7c.5.4 1 .7 1.6.7.7 0 1.2-.2 1.7-.7.3-.3.5-.7.5-1.2h-2.2v-.8h2.9v.4zM52 7.7h-2.7v1.9h2.5v.7h-2.5v1.9H52v.8h-3.5V7H52v.7zm3.3 5.3h-.8V7.7h-1.7V7H57v.7h-1.7V13zm4.6 0V7h.8v6h-.8zm4.2 0h-.8V7.7h-1.7V7h4.1v.7H64V13zm9.5-.8c-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2s.3-1.6.9-2.2c.6-.6 1.3-.9 2.2-.9.9 0 1.6.3 2.2.9.6.6.9 1.3.9 2.2 0 .9-.3 1.6-.9 2.2zm-3.8-.5c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.7s-.2-1.3-.7-1.7c-.4-.4-1-.7-1.6-.7-.6 0-1.2.2-1.6.7-.4.4-.7 1-.7 1.7s.2 1.3.7 1.7zm5.8 1.3V7h.9l2.9 4.7V7h.8v6h-.8l-3.1-4.9V13h-.7z"
      fill="#fff"
      stroke="#fff"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M68.1 21.8a4.2 4.2 0 0 0-4.3 4.3c0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3zm0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6zm-9.3-6.8a4.2 4.2 0 0 0-4.3 4.3c0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3zm0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6zm-11.1-5.5v1.8H52c-.1 1-.5 1.8-1 2.3-.6.6-1.6 1.3-3.3 1.3-2.7 0-4.7-2.1-4.7-4.8a4.72 4.72 0 0 1 8-3.5l1.3-1.3a6.4 6.4 0 0 0-4.5-1.8c-3.6 0-6.7 3-6.7 6.6 0 3.6 3.1 6.6 6.7 6.6 2 0 3.4-.6 4.6-1.9 1.2-1.2 1.6-2.9 1.6-4.2 0-.4 0-.8-.1-1.1h-6.2zm45.4 1.4c-.4-1-1.4-2.7-3.6-2.7s-4 1.7-4 4.3c0 2.4 1.8 4.3 4.2 4.3 1.9 0 3.1-1.2 3.5-1.9l-1.4-1c-.5.7-1.1 1.2-2.1 1.2s-1.6-.4-2.1-1.3l5.7-2.4-.2-.5zm-5.8 1.4c0-1.6 1.3-2.5 2.2-2.5.7 0 1.4.4 1.6.9l-3.8 1.6zM82.6 30h1.9V17.5h-1.9V30zm-3-7.3c-.5-.5-1.3-1-2.3-1-2.1 0-4.1 1.9-4.1 4.3s1.9 4.2 4.1 4.2c1 0 1.8-.5 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1.1 0-1.9-.8-2.1-1.5l-1.6.7c.5 1.1 1.7 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4V22h-1.8v.7zm-2.2 5.9c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.3 1.1 2.3 2.6s-1 2.6-2.3 2.6zm24.4-11.1h-4.5V30h1.9v-4.7h2.6c2.1 0 4.1-1.5 4.1-3.9s-2-3.9-4.1-3.9zm.1 6h-2.7v-4.3h2.7c1.4 0 2.2 1.2 2.2 2.1-.1 1.1-.9 2.2-2.2 2.2zm11.5-1.8c-1.4 0-2.8.6-3.3 1.9l1.7.7c.4-.7 1-.9 1.7-.9 1 0 1.9.6 2 1.6v.1c-.3-.2-1.1-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8 0 1.7 1.5 2.8 3.1 2.8 1.3 0 1.9-.6 2.4-1.2h.1v1h1.8v-4.8c-.2-2.2-1.9-3.5-4-3.5zm-.2 6.9c-.6 0-1.5-.3-1.5-1.1 0-1 1.1-1.3 2-1.3.8 0 1.2.2 1.7.4-.2 1.2-1.2 2-2.2 2zm10.5-6.6l-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8h-2zm-16.8 8h1.9V17.5h-1.9V30z"
      fill="#fff"
    />
    <linearGradient
      id="a"
      gradientUnits="userSpaceOnUse"
      x1="21.8"
      y1="33.29"
      x2="5.02"
      y2="16.51"
      gradientTransform="matrix(1 0 0 -1 0 42)"
    >
      <stop offset="0" stopColor="#00a0ff" />
      <stop offset="0.01" stopColor="#00a1ff" />
      <stop offset="0.26" stopColor="#00beff" />
      <stop offset="0.51" stopColor="#00d2ff" />
      <stop offset="0.76" stopColor="#00dfff" />
      <stop offset="1" stopColor="#00e3ff" />
    </linearGradient>
    <path
      d="M10.4 7.5c-.3.3-.4.8-.4 1.4V31c0 .6.2 1.1.5 1.4l.1.1L23 20.1v-.2L10.4 7.5z"
      fill="url(#a)"
    />
    <linearGradient
      id="b"
      gradientUnits="userSpaceOnUse"
      x1="33.83"
      y1="22"
      x2="9.64"
      y2="22"
      gradientTransform="matrix(1 0 0 -1 0 42)"
    >
      <stop offset="0" stopColor="#ffe000" />
      <stop offset="0.41" stopColor="#ffbd00" />
      <stop offset="0.78" stopColor="orange" />
      <stop offset="1" stopColor="#ff9c00" />
    </linearGradient>
    <path
      d="M27 24.3l-4.1-4.1v-.3l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7z"
      fill="url(#b)"
    />
    <linearGradient
      id="c"
      gradientUnits="userSpaceOnUse"
      x1="24.83"
      y1="19.7"
      x2="2.07"
      y2="-3.05"
      gradientTransform="matrix(1 0 0 -1 0 42)"
    >
      <stop offset="0" stopColor="#ff3a44" />
      <stop offset="1" stopColor="#c31162" />
    </linearGradient>
    <path d="M27.1 24.2L22.9 20 10.4 32.5c.5.5 1.2.5 2.1.1l14.6-8.4" fill="url(#c)" />
    <linearGradient
      id="d"
      gradientUnits="userSpaceOnUse"
      x1="7.3"
      y1="41.82"
      x2="17.46"
      y2="31.66"
      gradientTransform="matrix(1 0 0 -1 0 42)"
    >
      <stop offset="0" stopColor="#32a071" />
      <stop offset="0.07" stopColor="#2da771" />
      <stop offset="0.48" stopColor="#15cf74" />
      <stop offset="0.8" stopColor="#06e775" />
      <stop offset="1" stopColor="#00f076" />
    </linearGradient>
    <path d="M27.1 15.8L12.5 7.5c-.9-.5-1.6-.4-2.1.1L22.9 20l4.2-4.2z" fill="url(#d)" />
    <path d="M27 24.1l-14.5 8.2c-.8.5-1.5.4-2 0l-.1.1.1.1c.5.4 1.2.5 2 0L27 24.1z" opacity="0.2" />
    <path
      d="M10.4 32.3c-.3-.3-.4-.8-.4-1.4v.1c0 .6.2 1.1.5 1.4v-.1h-.1zm21.6-11l-5 2.8.1.1 4.9-2.8c.7-.4 1-.9 1-1.4 0 .5-.4.9-1 1.3z"
      opacity="0.12"
    />
    <path
      d="M12.5 7.6L32 18.7c.6.4 1 .8 1 1.3 0-.5-.3-1-1-1.4L12.5 7.5c-1.4-.8-2.5-.2-2.5 1.4V9c0-1.5 1.1-2.2 2.5-1.4z"
      opacity="0.25"
      fill="#fff"
    />
  </svg>
);

export const AppStoreBadge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 119.664 40">
    <path
      d="M110.135 0H9.535c-.367 0-.73 0-1.095.002-.306.002-.61.008-.919.013A13.215 13.215 0 0 0 5.517.19a6.665 6.665 0 0 0-1.9.627 6.438 6.438 0 0 0-1.62 1.18A6.258 6.258 0 0 0 .82 3.617 6.601 6.601 0 0 0 .195 5.52a12.993 12.993 0 0 0-.179 2.002c-.01.307-.01.615-.015.921V31.56c.005.31.006.61.015.921a12.992 12.992 0 0 0 .18 2.002 6.588 6.588 0 0 0 .624 1.905A6.208 6.208 0 0 0 1.998 38a6.274 6.274 0 0 0 1.618 1.179 6.7 6.7 0 0 0 1.901.63 13.455 13.455 0 0 0 2.004.177c.31.007.613.011.919.011.366.002.728.002 1.095.002h100.6c.36 0 .724 0 1.084-.002.304 0 .617-.004.922-.01a13.279 13.279 0 0 0 2-.178 6.804 6.804 0 0 0 1.908-.63A6.277 6.277 0 0 0 117.666 38a6.395 6.395 0 0 0 1.182-1.614 6.604 6.604 0 0 0 .619-1.905 13.506 13.506 0 0 0 .185-2.002c.004-.31.004-.61.004-.921.008-.364.008-.725.008-1.094V9.536c0-.366 0-.73-.008-1.092 0-.306 0-.614-.004-.92a13.507 13.507 0 0 0-.185-2.003 6.618 6.618 0 0 0-.62-1.903 6.466 6.466 0 0 0-2.798-2.8 6.768 6.768 0 0 0-1.908-.627 13.044 13.044 0 0 0-2-.176c-.305-.005-.618-.011-.922-.013-.36-.002-.725-.002-1.084-.002z"
      fill="#a6a6a6"
    />
    <path d="M8.445 39.125c-.305 0-.602-.004-.904-.01a12.687 12.687 0 0 1-1.87-.164 5.884 5.884 0 0 1-1.656-.548 5.406 5.406 0 0 1-1.397-1.016 5.32 5.32 0 0 1-1.02-1.397 5.722 5.722 0 0 1-.544-1.657 12.414 12.414 0 0 1-.166-1.875c-.007-.21-.015-.913-.015-.913v-23.1s.009-.692.015-.895a12.37 12.37 0 0 1 .165-1.872 5.755 5.755 0 0 1 .544-1.662 5.373 5.373 0 0 1 1.015-1.398 5.565 5.565 0 0 1 1.402-1.023 5.823 5.823 0 0 1 1.653-.544A12.586 12.586 0 0 1 7.543.887l.902-.012h102.769l.913.013a12.385 12.385 0 0 1 1.858.162 5.938 5.938 0 0 1 1.671.548 5.594 5.594 0 0 1 2.415 2.42 5.763 5.763 0 0 1 .535 1.649 12.995 12.995 0 0 1 .174 1.887c.003.283.003.588.003.89.008.375.008.732.008 1.092v20.929c0 .363 0 .718-.008 1.075 0 .325 0 .623-.004.93a12.731 12.731 0 0 1-.17 1.853 5.739 5.739 0 0 1-.54 1.67 5.48 5.48 0 0 1-1.016 1.386 5.413 5.413 0 0 1-1.4 1.022 5.862 5.862 0 0 1-1.668.55 12.542 12.542 0 0 1-1.869.163c-.293.007-.6.011-.897.011l-1.084.002z" />
    <path
      d="M24.769 20.3a4.949 4.949 0 0 1 2.356-4.151 5.066 5.066 0 0 0-3.99-2.158c-1.68-.176-3.308 1.005-4.164 1.005-.872 0-2.19-.988-3.608-.958a5.315 5.315 0 0 0-4.473 2.728c-1.934 3.348-.491 8.269 1.361 10.976.927 1.325 2.01 2.805 3.428 2.753 1.387-.058 1.905-.885 3.58-.885 1.658 0 2.144.885 3.59.852 1.489-.025 2.426-1.332 3.32-2.67a10.962 10.962 0 0 0 1.52-3.092 4.782 4.782 0 0 1-2.92-4.4zm-2.732-8.09a4.872 4.872 0 0 0 1.115-3.49 4.957 4.957 0 0 0-3.208 1.66 4.636 4.636 0 0 0-1.144 3.36 4.1 4.1 0 0 0 3.237-1.53z"
      fill="#fff"
    />
    <path
      d="M42.302 27.14H37.57l-1.137 3.356h-2.005l4.484-12.418h2.083l4.483 12.418h-2.039zm-4.243-1.55h3.752l-1.85-5.446h-.051zm17.101.38c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 0 1-2.848-1.583h-.043v4.484h-1.86V21.442h1.8v1.506h.033a3.212 3.212 0 0 1 2.883-1.6c2.298 0 3.813 1.816 3.813 4.622zm-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.393-1.197 2.393-3.046zm11.875 0c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 0 1-2.848-1.583h-.043v4.484h-1.859V21.442h1.799v1.506h.034a3.212 3.212 0 0 1 2.883-1.6c2.298 0 3.813 1.816 3.813 4.622zm-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.392-1.197 2.392-3.046zm8.495 1.066c.138 1.232 1.334 2.04 2.97 2.04 1.566 0 2.693-.808 2.693-1.919 0-.964-.68-1.54-2.29-1.936l-1.609-.388c-2.28-.55-3.339-1.617-3.339-3.348 0-2.142 1.867-3.614 4.519-3.614 2.624 0 4.423 1.472 4.483 3.614h-1.876c-.112-1.239-1.136-1.987-2.634-1.987s-2.521.757-2.521 1.858c0 .878.654 1.395 2.255 1.79l1.368.336c2.548.603 3.606 1.626 3.606 3.443 0 2.323-1.85 3.778-4.793 3.778-2.754 0-4.614-1.42-4.734-3.667zM83.346 19.3v2.142h1.722v1.472h-1.722v4.991c0 .776.345 1.137 1.102 1.137a5.808 5.808 0 0 0 .611-.043v1.463a5.104 5.104 0 0 1-1.032.086c-1.833 0-2.548-.689-2.548-2.445v-5.189h-1.316v-1.472h1.316V19.3zm2.719 6.67c0-2.849 1.678-4.639 4.294-4.639 2.625 0 4.295 1.79 4.295 4.639 0 2.856-1.661 4.638-4.295 4.638-2.633 0-4.294-1.782-4.294-4.638zm6.695 0c0-1.954-.895-3.108-2.401-3.108s-2.4 1.162-2.4 3.108c0 1.962.894 3.106 2.4 3.106s2.401-1.144 2.401-3.106zm3.426-4.528h1.773v1.541h.043a2.16 2.16 0 0 1 2.177-1.635 2.866 2.866 0 0 1 .637.069v1.738a2.598 2.598 0 0 0-.835-.112 1.873 1.873 0 0 0-1.937 2.083v5.37h-1.858zm13.198 6.395c-.25 1.643-1.85 2.771-3.898 2.771-2.634 0-4.269-1.764-4.269-4.595 0-2.84 1.644-4.682 4.19-4.682 2.506 0 4.08 1.72 4.08 4.466v.637h-6.394v.112a2.358 2.358 0 0 0 2.436 2.564 2.048 2.048 0 0 0 2.09-1.273zm-6.282-2.702h4.526a2.177 2.177 0 0 0-2.22-2.298 2.292 2.292 0 0 0-2.306 2.298z"
      fill="#fff"
    />
    <path
      d="M37.826 8.731a2.64 2.64 0 0 1 2.808 2.965c0 1.906-1.03 3.002-2.808 3.002h-2.155V8.73zm-1.228 5.123h1.125a1.876 1.876 0 0 0 1.967-2.146 1.881 1.881 0 0 0-1.967-2.134h-1.125zm5.082-1.41a2.133 2.133 0 1 1 4.248 0 2.134 2.134 0 1 1-4.247 0zm3.334 0c0-.976-.439-1.547-1.208-1.547-.773 0-1.207.571-1.207 1.547 0 .984.434 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55zm6.559 2.254h-.922l-.93-3.317h-.07l-.927 3.317h-.913l-1.242-4.503h.902l.806 3.436h.067l.926-3.436h.852l.926 3.436h.07l.803-3.436h.889zm2.281-4.503h.855v.715h.066a1.348 1.348 0 0 1 1.344-.802 1.465 1.465 0 0 1 1.559 1.675v2.915h-.889v-2.692c0-.724-.314-1.084-.972-1.084a1.033 1.033 0 0 0-1.075 1.141v2.635h-.888zm5.24-1.758h.888v6.26h-.888zm2.124 4.007a2.133 2.133 0 1 1 4.247 0 2.134 2.134 0 1 1-4.247 0zm3.333 0c0-.976-.439-1.547-1.208-1.547-.773 0-1.207.571-1.207 1.547 0 .984.434 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55zm1.849.98c0-.81.604-1.278 1.676-1.344l1.22-.07v-.389c0-.475-.315-.744-.922-.744-.497 0-.84.182-.939.5h-.86c.09-.773.818-1.27 1.84-1.27 1.128 0 1.765.563 1.765 1.514v3.077h-.855v-.633h-.07a1.515 1.515 0 0 1-1.353.707 1.36 1.36 0 0 1-1.501-1.348zm2.895-.384v-.377l-1.1.07c-.62.042-.9.253-.9.65 0 .405.351.64.834.64a1.062 1.062 0 0 0 1.166-.983zm2.053-.596c0-1.423.732-2.324 1.87-2.324a1.484 1.484 0 0 1 1.38.79h.067V8.437h.888v6.26h-.851v-.71h-.07a1.563 1.563 0 0 1-1.415.785c-1.145 0-1.869-.901-1.869-2.328zm.918 0c0 .955.45 1.53 1.203 1.53.75 0 1.212-.583 1.212-1.526 0-.938-.468-1.53-1.212-1.53-.748 0-1.203.58-1.203 1.526zm6.964 0a2.133 2.133 0 1 1 4.247 0 2.134 2.134 0 1 1-4.247 0zm3.333 0c0-.976-.438-1.547-1.208-1.547-.772 0-1.207.571-1.207 1.547 0 .984.435 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55zm2.107-2.249h.855v.715h.066a1.348 1.348 0 0 1 1.344-.802 1.465 1.465 0 0 1 1.559 1.675v2.915h-.889v-2.692c0-.724-.314-1.084-.972-1.084a1.033 1.033 0 0 0-1.075 1.141v2.635h-.889zm8.845-1.121v1.141h.976v.749h-.976v2.315c0 .472.194.679.637.679a2.967 2.967 0 0 0 .339-.021v.74a2.916 2.916 0 0 1-.484.046c-.988 0-1.381-.348-1.381-1.216v-2.543h-.715v-.749h.715V9.074zm2.19-.637h.88v2.481h.07a1.386 1.386 0 0 1 1.374-.806 1.483 1.483 0 0 1 1.55 1.679v2.907h-.889V12.01c0-.72-.335-1.084-.963-1.084a1.052 1.052 0 0 0-1.134 1.142v2.63h-.888zm9.056 5.045a1.828 1.828 0 0 1-1.95 1.303 2.045 2.045 0 0 1-2.081-2.325 2.077 2.077 0 0 1 2.076-2.352c1.253 0 2.009.856 2.009 2.27v.31h-3.18v.05a1.19 1.19 0 0 0 1.2 1.29 1.08 1.08 0 0 0 1.07-.546zm-3.126-1.451h2.275a1.086 1.086 0 0 0-1.109-1.167 1.152 1.152 0 0 0-1.166 1.167z"
      fill="#fff"
    />
  </svg>
);

export const Plus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="32" viewBox="0 0 21 32" {...props}>
    <path d="M12.768 17.92v6.688h-4.16v-6.688h-6.816v-4.032h6.784v-6.688h4.16v6.688h6.816v4.032h-6.784z" />
  </svg>
);

export const Question: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="28" viewBox="0 0 17 28" {...props}>
    <path d="M16.864 8.736q0 1.056-0.256 1.856t-0.72 1.472-1.12 1.264-1.488 1.232q-0.512 0.416-0.848 0.736t-0.528 0.656-0.272 0.704-0.080 0.88v0.832h-4.992v-1.216q0-0.832 0.16-1.488t0.48-1.2 0.784-1.056 1.104-1.056l1.056-0.992q0.544-0.48 0.928-1.008t0.384-1.264q0-1.024-0.624-1.632t-1.712-0.608q-1.344 0-2.016 0.912t-0.736 2.064l-5.088-0.544q0.192-1.728 0.88-3.040t1.776-2.176 2.464-1.296 2.912-0.432q1.44 0 2.8 0.368t2.416 1.152 1.696 2 0.64 2.88zM12.192 22.88q0 1.28-0.896 2.16t-2.208 0.88q-0.64 0-1.2-0.224t-0.992-0.64-0.688-0.96-0.256-1.184q0-0.608 0.24-1.168t0.672-0.976 1.008-0.656 1.216-0.24 1.2 0.24 0.992 0.64 0.672 0.96 0.24 1.168z" />
  </svg>
);

export const AvatarAnomaly = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FF7B00"
        stroke="#FFF"
        strokeWidth="1.2"
        d="M7.956 10.088a4.562 4.562 0 0 0 5-.2l.015-.01.009-.007a4.554 4.554 0 0 0 .652-6.782 4.554 4.554 0 0 0-6.43-.225 4.557 4.557 0 0 0-.953 5.389 1.189 1.189 0 0 0-.961.314l-.213.199-2.25 2.096-.003.002a1.203 1.203 0 0 0-.057 1.693l.656.704a1.2 1.2 0 0 0 1.177.339l.012-.004.042-.012c.048-.015.048-.015.109-.04.128-.053.247-.13.352-.227l2.249-2.099.21-.196c.27-.25.4-.594.384-.934z"
      />
      <path
        fill="#FFF"
        d="M8.669 7.718a2.295 2.295 0 0 1 .113-3.24 2.295 2.295 0 0 1 3.24.113c.818.877.815 2.23.023 3.103l-.282.263a2.296 2.296 0 0 1-3.094-.24z"
      />
    </g>
  </svg>
);

interface StarProps extends React.SVGProps<SVGSVGElement> {
  circleFill?: string;
}
export const Star = ({ circleFill = '#fff', ...rest }: StarProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <g fill="none" fillRule="nonzero" transform="translate(3 3)">
        <rect
          width="21"
          height="21"
          x="-1.5"
          y="-1.5"
          fill="#FFCC68"
          stroke={circleFill}
          strokeWidth="3"
          rx="10"
        />
        <path
          fill="#FFF"
          d="M9 11.908l-3.174 1.46.408-3.47-2.37-2.567 3.427-.684L9 3.6l1.71 3.047 3.426.684-2.37 2.568.408 3.47z"
        />
      </g>
    </svg>
  );
};

export const BorderlessStar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
    <g fill="none" fillRule="nonzero">
      <rect width="16" height="16" fill="#FFCC68" rx="8" />
      <path
        fill="#FFF"
        d="M8 10.585l-2.821 1.298.363-3.084-2.107-2.282 3.046-.608L8 3.2l1.52 2.709 3.045.608-2.107 2.282.363 3.084z"
      />
    </g>
  </svg>
);
export const Visibility = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    style={{ marginTop: -2 }}
    {...props}
  >
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
  </svg>
);

export const VisibilityOff = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    style={{ marginTop: -2 }}
    {...props}
  >
    <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
  </svg>
);

export const DragHandle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 8 12">
    <circle cx="2" cy="2" r="1.3" />
    <circle cx="2" cy="6" r="1.3" />
    <circle cx="2" cy="10" r="1.3" />
    <circle cx="6" cy="2" r="1.3" />
    <circle cx="6" cy="6" r="1.3" />
    <circle cx="6" cy="10" r="1.3" />
  </svg>
);

export const SortableDragHandle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00004 3.33333C9.00004 2.59695 9.59699 2 10.3334 2C11.0698 2 11.6667 2.59695 11.6667 3.33333C11.6667 4.06971 11.0698 4.66667 10.3334 4.66667C9.59699 4.66667 9.00004 4.06971 9.00004 3.33333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00004 8C9.00004 7.26362 9.59699 6.66667 10.3334 6.66667C11.0698 6.66667 11.6667 7.26362 11.6667 8C11.6667 8.73638 11.0698 9.33333 10.3334 9.33333C9.59699 9.33333 9.00004 8.73638 9.00004 8Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00004 12.6667C9.00004 11.9303 9.59699 11.3333 10.3334 11.3333C11.0698 11.3333 11.6667 11.9303 11.6667 12.6667C11.6667 13.403 11.0698 14 10.3334 14C9.59699 14 9.00004 13.403 9.00004 12.6667Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.33337 3.33333C4.33337 2.59695 4.93033 2 5.66671 2C6.40309 2 7.00004 2.59695 7.00004 3.33333C7.00004 4.06971 6.40309 4.66667 5.66671 4.66667C4.93033 4.66667 4.33337 4.06971 4.33337 3.33333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.33337 8C4.33337 7.26362 4.93033 6.66667 5.66671 6.66667C6.40309 6.66667 7.00004 7.26362 7.00004 8C7.00004 8.73638 6.40309 9.33333 5.66671 9.33333C4.93033 9.33333 4.33337 8.73638 4.33337 8Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.33337 12.6667C4.33337 11.9303 4.93033 11.3333 5.66671 11.3333C6.40309 11.3333 7.00004 11.9303 7.00004 12.6667C7.00004 13.403 6.40309 14 5.66671 14C4.93033 14 4.33337 13.403 4.33337 12.6667Z"
      fill="currentColor"
    />
  </svg>
);

export const PlayIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
      <g fill="none" fillRule="evenodd">
        <circle cx="27.642" cy="27.642" r="27.642" fill="#a7aab1" />
        <path
          fill="#FFF"
          d="M36.341 28.884l-11.22 8.976a1 1 0 0 1-1.625-.78V19.126a1 1 0 0 1 1.625-.781l11.22 8.976a1 1 0 0 1 0 1.562z"
        />
      </g>
    </svg>
  );
};

/** @deprecated Use via CustomIcon.Info from timelyapp/react */
export const InfoIcon = ({
  backgroundColor,
  color,
  ...props
}: React.SVGProps<SVGSVGElement> & { backgroundColor?: string; color?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle
          cx="9"
          cy="9"
          r="9"
          fill={backgroundColor || '#32386F'}
          fillOpacity={backgroundColor ? '1' : '.089'}
        />
        <path
          fill={color || '#000'}
          fillOpacity={color ? '1' : '.416'}
          fillRule="nonzero"
          d="M11.086 5.498a.96.96 0 0 1-.294.703.96.96 0 0 1-.704.294.96.96 0 0 1-.703-.294.96.96 0 0 1-.294-.703c0-.277.098-.513.294-.707a.965.965 0 0 1 .703-.291c.273 0 .508.097.704.291.196.194.294.43.294.707zm-1.074 6.305h.645c-.545 1.164-1.308 1.746-2.289 1.746-.397 0-.695-.083-.895-.25-.2-.165-.3-.413-.3-.741 0-.192.082-.529.248-1.01L8.19 9.34c.06-.17.09-.281.09-.332 0-.052-.012-.089-.036-.112-.023-.024-.06-.035-.112-.035-.217 0-.473.277-.767.83H6.75C7.3 8.504 8.076 7.91 9.078 7.91c.354 0 .629.086.825.259.196.172.294.41.294.713 0 .221-.087.573-.262 1.055l-.742 2.02c-.107.286-.16.466-.16.538a.14.14 0 0 0 .042.109c.027.025.067.038.118.038.11 0 .253-.096.425-.288a2.64 2.64 0 0 0 .394-.55z"
        />
      </g>
    </svg>
  );
};

export const InfoIconWithoutCircle = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          id="Solid"
          d="M8.49992 1.71326C8.50173 1.87255 8.47259 2.03055 8.41429 2.17752C8.35598 2.32449 8.26975 2.45731 8.1609 2.56782C8.05594 2.68271 7.92975 2.77371 7.79013 2.83517C7.6505 2.89664 7.50041 2.92728 7.34911 2.9252C7.198 2.92712 7.04813 2.8964 6.90871 2.83493C6.76929 2.77347 6.64329 2.68256 6.53847 2.56782C6.42962 2.45731 6.34339 2.32449 6.28508 2.17752C6.22678 2.03055 6.19763 1.87255 6.19945 1.71326C6.19945 1.37654 6.31246 1.08966 6.53847 0.853833C6.64379 0.740036 6.76997 0.649998 6.90932 0.589188C7.04867 0.528379 7.1983 0.498068 7.34911 0.500095C7.66391 0.500095 7.93489 0.618008 8.1609 0.853833C8.38691 1.08966 8.49992 1.37654 8.49992 1.71326ZM7.26147 9.37757H8.00523C7.37678 10.7925 6.49695 11.5 5.36574 11.5C4.90796 11.5 4.56433 11.3991 4.3337 11.1961C4.10308 10.9955 3.98777 10.6941 3.98777 10.2953C3.98777 10.062 4.08232 9.6523 4.27374 9.0676L5.16049 6.38357C5.22968 6.17692 5.26427 6.04199 5.26427 5.97999C5.26427 5.91678 5.25043 5.8718 5.22276 5.84384C5.19624 5.81467 5.15357 5.8013 5.09361 5.8013C4.84338 5.8013 4.54818 6.13802 4.20917 6.81024H3.5C4.13421 5.36733 5.02903 4.64527 6.18446 4.64527C6.59266 4.64527 6.90977 4.74981 7.13578 4.96011C7.36179 5.16919 7.4748 5.4585 7.4748 5.82683C7.4748 6.09547 7.37448 6.52336 7.17268 7.10928L6.31707 9.56478C6.19368 9.91244 6.13257 10.1312 6.13257 10.2188C6.13111 10.2432 6.13469 10.2677 6.14305 10.2906C6.15141 10.3135 6.16435 10.3342 6.181 10.3513C6.21213 10.3817 6.25826 10.3975 6.31707 10.3975C6.44391 10.3975 6.60881 10.2808 6.80714 10.0474C6.98516 9.84597 7.13786 9.62005 7.26147 9.37757Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const Arrow = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" {...props}>
      <g
        fill="none"
        fillRule="nonzero"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      >
        <path d="M4.182 11V1.676M1.283 3.93l2.81-2.811 2.811 2.81" />
      </g>
    </svg>
  );
};

export const Plug = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 12 19" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.167 5.833a.5.5 0 0 1 .5.5V10a4.168 4.168 0 0 1-3.334 4.083v3.75a.5.5 0 0 1-.5.5h-.666a.5.5 0 0 1-.5-.5V13.25a4.169 4.169 0 0 0 3.328-3.876L10 9.167V5.833h1.167zm-5.334-5c.46 0 .834.373.834.834v2.5h1.166a.5.5 0 0 1 .5.5v3.666A4.168 4.168 0 0 1 5 12.417l-.001.832.001.001V16.167a.5.5 0 0 1-.5.5h-.667a.5.5 0 0 1-.5-.5v-3.75A4.168 4.168 0 0 1 0 8.333V4.667a.5.5 0 0 1 .5-.5h1.167v-2.5a.833.833 0 1 1 1.666 0v2.5H5v-2.5c0-.46.373-.834.833-.834z"
      />
    </svg>
  );
};

export const AvatarCloud = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h18v18H0z" />
        <path
          fill="currentColor"
          stroke="#FFF"
          strokeWidth="2"
          d="M6.793 14.312l-3.062 1.567a1.1 1.1 0 0 1-1.487-1.465l1.342-2.723a4 4 0 0 1 1.257-7.084 4.601 4.601 0 0 1 4.12-2.552h.074a4.601 4.601 0 0 1 4.12 2.552 4.002 4.002 0 0 1 0 7.696 4.601 4.601 0 0 1-4.12 2.552h-.074c-.768 0-1.51-.19-2.17-.543z"
        />
      </g>
    </svg>
  );
};

export const AvatarArchived = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h18v18H0z" />
        <path
          fill="currentColor"
          stroke="#FFF"
          strokeWidth="2"
          d="M5 6h8a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zM4 3h10a2 2 0 1 1 0 4H4a2 2 0 1 1 0-4z"
        />
      </g>
    </svg>
  );
};

export const AvatarWarning = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h18v18H0z" />
        <path
          fill="currentColor"
          stroke="#FFF"
          strokeWidth="2"
          d="M8 1h2a2 2 0 0 1 1.982 2.265l-.804 6A2 2 0 0 1 9.196 11h-.392a2 2 0 0 1-1.982-1.735l-.804-6A2 2 0 0 1 8.001 1zm.729 10h.542a1.8 1.8 0 0 1 1.8 1.8v.4a1.8 1.8 0 0 1-1.8 1.8H8.73a1.8 1.8 0 0 1-1.8-1.8v-.4a1.8 1.8 0 0 1 1.8-1.8z"
        />
      </g>
    </svg>
  );
};
export const AvatarCreate = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h18v18H0z" />
        <path
          fill="currentColor"
          stroke="#FFF"
          strokeWidth="2"
          d="M4.645 13.92l-2.647-2.604a1.981 1.981 0 0 1-.023-2.802l.012-.011A1.997 1.997 0 0 1 4.8 8.49L6.26 9.93l7.065-7.113a1.979 1.979 0 0 1 2.798-.01l.005.005c.773.774.776 2.027.005 2.803l-8.481 8.54c-.77.776-2.023.78-2.799.01l-.005-.005a1.993 1.993 0 0 1-.204-.239z"
        />
      </g>
    </svg>
  );
};

export const AvatarDeleted = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        stroke="#FFF"
        strokeWidth="2"
        d="M9 6.172l2.121-2.122A2 2 0 1 1 13.95 6.88L11.828 9l2.122 2.121a2 2 0 1 1-2.829 2.829L9 11.828 6.879 13.95A2 2 0 1 1 4.05 11.12L6.172 9 4.05 6.879A2 2 0 1 1 6.88 4.05L9 6.172z"
      />
    </svg>
  );
};
export const AvatarEdit = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h18v18H0z" />
        <path
          fill="currentColor"
          stroke="#FFF"
          strokeWidth="2"
          d="M9.599 5.212l3.831 3.831-5.376 5.376a1.2 1.2 0 0 1-.528.308l-2.964.82a1.2 1.2 0 0 1-1.476-1.48l.83-2.955a1.2 1.2 0 0 1 .307-.524l5.376-5.376zm4.686-2.566l1.71 1.71a1.5 1.5 0 0 1 0 2.122l-2.77 2.77-3.832-3.83 2.77-2.772a1.5 1.5 0 0 1 2.122 0z"
        />
      </g>
    </svg>
  );
};

export const BudgetPig = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.01 9.904H1a1 1 0 0 1-1-1v-.01a1 1 0 0 1 1-1h1.029c.084 0 .165.01.243.03A7.003 7.003 0 0 1 9.01 2.827h4.111l.894-2.691a.2.2 0 0 1 .348-.06l3.617 4.654a7.02 7.02 0 0 1 1.55 2.14h.884a1 1 0 0 1 .97.755l.588 2.32a1 1 0 0 1-.729 1.216l-1.218.302a6.99 6.99 0 0 1-1.983 3.554l-2.608 3.574a1 1 0 0 1-.808.41h-.51a1 1 0 0 1-1-1V16.98h-4.04v1.022a1 1 0 0 1-1 1h-.513a1 1 0 0 1-.805-.407l-2.71-3.677A6.978 6.978 0 0 1 2.01 9.98v-.076zm14.134-4.043a1.01 1.01 0 1 0 .001 2.02 1.01 1.01 0 0 0-.001-2.02z"
      />
    </svg>
  );
};
export const ClientTie = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="18" viewBox="0 0 8 18" {...props}>
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M2.754 4a1 1 0 0 1-.96-.719L1.026.659A.5.5 0 0 1 1.5 0h5a.5.5 0 0 1 .475.658l-.769 2.623a1 1 0 0 1-.96.719H2.754zm2.494 2a1 1 0 0 1 .97.76l1.77 7.126a.5.5 0 0 1-.134.468l-3.5 3.5a.502.502 0 0 1-.708 0l-3.5-3.5a.5.5 0 0 1-.133-.468L1.775 6.76A1 1 0 0 1 2.746 6h2.502z"
      />
    </svg>
  );
};

export const Gift = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" {...props}>
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth=".5"
        d="M16.467 4.19h-4.032c.194-.323.297-.692.298-1.068-.005-.886-.557-1.676-1.385-1.986-.829-.31-1.763-.077-2.348.587-.585-.664-1.52-.898-2.348-.587-.828.31-1.38 1.1-1.385 1.986.001.376.104.745.298 1.067H1.533c-.294 0-.533.24-.533.534v3.736c0 .295.239.534.533.534v7.473c0 .295.24.534.534.534h13.866c.295 0 .534-.239.534-.534V8.993c.294 0 .533-.239.533-.534V4.723c0-.295-.239-.534-.533-.534zm-.534 3.736h-6.4v-2.67h6.4v2.67zM10.6 2.054c.59 0 1.067.478 1.067 1.068 0 .59-.478 1.067-1.067 1.067H9.533V3.122c0-.59.478-1.068 1.067-1.068zM6.333 3.122c0-.59.478-1.068 1.067-1.068.59 0 1.067.478 1.067 1.068v1.067H7.4c-.59 0-1.067-.478-1.067-1.067zM2.067 5.257h6.4v2.669h-6.4v-2.67zM2.6 8.993h5.867v6.94H2.6v-6.94zm12.8 6.94H9.533v-6.94H15.4v6.94z"
      />
    </svg>
  );
};

export const ExternalLink = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1 .046v7h7v1H0v-8h1zM4.51 0l3.42.026v.089h.09l.026 3.42-.855-.006-.016-1.951L3.38 5.374l-.707-.707L6.468.87 4.517.855 4.51 0z"
      />
    </svg>
  );
};

export const ChainLink = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0)">
      <path
        fill="currentColor"
        d="M5.37004 14.9999C5.14044 15.0003 4.91305 14.9552 4.70093 14.8673C4.48881 14.7794 4.29616 14.6505 4.13404 14.4879L1.51304 11.8659C1.3504 11.7035 1.22138 11.5106 1.13334 11.2982C1.04531 11.0859 1 10.8583 1 10.6284C1 10.3986 1.04531 10.171 1.13334 9.95861C1.22138 9.74627 1.3504 9.55337 1.51304 9.39093L3.97404 6.96593C4.11718 6.83434 4.30583 6.76348 4.50021 6.7683C4.69459 6.77311 4.8795 6.85323 5.01595 6.99175C5.15239 7.13028 5.22971 7.31637 5.23159 7.5108C5.23348 7.70523 5.15978 7.89279 5.02604 8.03393L2.56904 10.4559C2.52353 10.5026 2.49807 10.5652 2.49807 10.6304C2.49807 10.6956 2.52353 10.7582 2.56904 10.8049L5.19004 13.4269C5.23707 13.4737 5.30071 13.5 5.36704 13.5C5.43337 13.5 5.49701 13.4737 5.54404 13.4269L7.96604 10.9739C8.03417 10.8998 8.11652 10.8402 8.20819 10.7986C8.29985 10.757 8.39896 10.7342 8.49959 10.7317C8.60023 10.7293 8.70034 10.747 8.79395 10.7841C8.88757 10.8211 8.97277 10.8766 9.04449 10.9472C9.11621 11.0178 9.17297 11.1022 9.21139 11.1952C9.24982 11.2883 9.26912 11.3881 9.26814 11.4888C9.26717 11.5894 9.24594 11.6889 9.20572 11.7812C9.1655 11.8734 9.10711 11.9567 9.03404 12.0259L6.61304 14.4829C6.45014 14.6468 6.25647 14.7768 6.04315 14.8655C5.82983 14.9542 5.60108 14.9999 5.37004 14.9999Z"
      />
      <path
        fill="currentColor"
        d="M10.9661 9.02597C10.8969 8.95588 10.8423 8.87285 10.8052 8.78162C10.7682 8.6904 10.7495 8.59276 10.7503 8.49431C10.751 8.39586 10.7712 8.29852 10.8096 8.20787C10.848 8.11721 10.9039 8.03501 10.9741 7.96597L13.4311 5.54397C13.4766 5.49729 13.502 5.43467 13.502 5.36947C13.502 5.30428 13.4766 5.24166 13.4311 5.19497L10.8061 2.57297C10.759 2.5262 10.6954 2.49994 10.6291 2.49994C10.5627 2.49994 10.4991 2.5262 10.4521 2.57297L8.03405 5.02597C7.89291 5.15971 7.70535 5.23341 7.51092 5.23152C7.3165 5.22964 7.1304 5.15232 6.99188 5.01588C6.85335 4.87943 6.77324 4.69452 6.76842 4.50014C6.7636 4.30577 6.83446 4.11711 6.96605 3.97397L9.38705 1.51697C9.54976 1.35409 9.74298 1.22487 9.95567 1.13671C10.1683 1.04855 10.3963 1.00317 10.6266 1.00317C10.8568 1.00317 11.0848 1.04855 11.2974 1.13671C11.5101 1.22487 11.7033 1.35409 11.8661 1.51697L14.4871 4.13797C14.6497 4.30041 14.7787 4.49332 14.8667 4.70566C14.9548 4.918 15.0001 5.14561 15.0001 5.37547C15.0001 5.60534 14.9548 5.83295 14.8667 6.04529C14.7787 6.25763 14.6497 6.45053 14.4871 6.61297L12.0261 9.03397C11.956 9.10311 11.8729 9.15776 11.7817 9.19478C11.6905 9.2318 11.5928 9.25048 11.4944 9.24974C11.3959 9.24899 11.2986 9.22885 11.2079 9.19045C11.1173 9.15206 11.0351 9.09616 10.9661 9.02597Z"
      />
      <path
        fill="currentColor"
        d="M6.50007 10.2499C6.35183 10.2498 6.20696 10.2057 6.08374 10.1233C5.96053 10.0409 5.8645 9.9238 5.80779 9.78683C5.75107 9.64987 5.73622 9.49917 5.76511 9.35377C5.79399 9.20837 5.86532 9.0748 5.97007 8.96991L8.97007 5.96991C9.03874 5.89622 9.12154 5.83712 9.21354 5.79613C9.30553 5.75514 9.40485 5.73309 9.50555 5.73132C9.60625 5.72954 9.70628 5.74807 9.79967 5.78579C9.89306 5.82351 9.97789 5.87965 10.0491 5.95087C10.1203 6.02209 10.1765 6.10692 10.2142 6.20031C10.2519 6.2937 10.2704 6.39373 10.2687 6.49443C10.2669 6.59513 10.2448 6.69445 10.2039 6.78645C10.1629 6.87845 10.1038 6.96125 10.0301 7.02991L7.03007 10.0299C6.96069 10.0998 6.87812 10.1553 6.78714 10.1931C6.69616 10.2308 6.59858 10.2502 6.50007 10.2499Z"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="14" height="14" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export const DownArrow = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 8 10" {...props}>
      <path d="M6.40999 5.0779L5.11665 6.37057C5.06898 6.41836 4.99719 6.43268 4.93483 6.40683C4.87247 6.38098 4.83187 6.32007 4.83199 6.25257V0.999901C4.83199 0.539664 4.45889 0.166568 3.99865 0.166568C3.53842 0.166568 3.16532 0.539664 3.16532 0.999901V6.25257C3.16517 6.31978 3.12467 6.38032 3.0626 6.40611C3.00054 6.4319 2.92905 6.41788 2.88132 6.37057L1.58799 5.0779C1.26269 4.75261 0.735283 4.75261 0.409987 5.0779C0.0846917 5.4032 0.0846917 5.93061 0.409987 6.2559L3.40999 9.2559C3.56616 9.41219 3.77804 9.5 3.99899 9.5C4.21993 9.5 4.43181 9.41219 4.58799 9.2559L7.58799 6.2559C7.91328 5.93061 7.91328 5.4032 7.58799 5.0779C7.26269 4.75261 6.73528 4.75261 6.40999 5.0779Z" />
    </svg>
  );
};

export const DownDoubleChevron = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" {...props}>
      <path
        d="M1 8L6 13L11 8M1 1L6 6L11 1"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SmallDownArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="8" height="4" viewBox="0 0 8 4" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.14645 0.853553L4.35355 3.64645C4.15829 3.84171 3.84171 3.84171 3.64645 3.64645L0.853553 0.853553C0.538571 0.538571 0.761654 0 1.20711 0H6.79289C7.23835 0 7.46143 0.53857 7.14645 0.853553Z" />
  </svg>
);

export const SmallRightArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="4" height="8" viewBox="0 0 4 8" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0.853552 0.853553L3.64645 3.64645C3.84171 3.84171 3.84171 4.15829 3.64645 4.35355L0.853553 7.14645C0.538571 7.46143 -3.3293e-08 7.23835 -5.27643e-08 6.79289L-2.96927e-07 1.20711C-3.16398e-07 0.761654 0.53857 0.53857 0.853552 0.853553Z" />
  </svg>
);

export const SmallUpArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="8" height="4" viewBox="0 0 8 4" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.14645 3.14645L4.35355 0.353553C4.15829 0.158291 3.84171 0.158291 3.64645 0.353553L0.853553 3.14645C0.538571 3.46143 0.761654 4 1.20711 4H6.79289C7.23835 4 7.46143 3.46143 7.14645 3.14645Z" />
  </svg>
);

export const EmptyUserAvatar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
      fill="#ECEAEF"
    />
    <path
      d="M23.9746 23.8753C23.8968 23.9523 22.4608 25.6094 19.7832 25.6094C17.1049 25.6094 15.6689 23.9142 15.6307 23.8753C15.0481 23.1436 13.9614 23.0276 13.2239 23.6059C12.4872 24.1835 12.3705 25.2623 12.9524 25.9947C13.0691 26.11 15.437 29 19.7832 29C24.1294 29 26.4974 26.1107 26.6133 25.9947C26.8908 25.6508 27.0219 25.2115 26.9784 24.7718C26.9348 24.332 26.7202 23.927 26.3807 23.6441C25.6432 23.0665 24.5565 23.1818 23.9746 23.8753Z"
      fill="#383144"
      fillOpacity="0.4"
    />
    <path
      d="M11.4183 17.8367C12.7539 17.8367 13.8367 16.7539 13.8367 15.4183C13.8367 14.0827 12.7539 13 11.4183 13C10.0827 13 9 14.0827 9 15.4183C9 16.7539 10.0827 17.8367 11.4183 17.8367Z"
      fill="#383144"
      fillOpacity="0.4"
    />
    <path
      d="M28.222 17.8367C29.5576 17.8367 30.6404 16.7539 30.6404 15.4183C30.6404 14.0827 29.5576 13 28.222 13C26.8864 13 25.8037 14.0827 25.8037 15.4183C25.8037 16.7539 26.8864 17.8367 28.222 17.8367Z"
      fill="#383144"
      fillOpacity="0.4"
    />
  </svg>
);

export const ClockIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 16C6.41775 16 4.87104 15.5308 3.55544 14.6518C2.23985 13.7727 1.21447 12.5233 0.608967 11.0615C0.00346633 9.59966 -0.15496 7.99113 0.153721 6.43928C0.462403 4.88743 1.22433 3.46197 2.34315 2.34315C3.46197 1.22433 4.88743 0.462403 6.43928 0.153721C7.99113 -0.15496 9.59966 0.00346633 11.0615 0.608967C12.5233 1.21447 13.7727 2.23985 14.6518 3.55544C15.5308 4.87104 16 6.41775 16 8C15.9976 10.121 15.154 12.1544 13.6542 13.6542C12.1544 15.154 10.121 15.9976 8 16ZM8 2.28572C6.86983 2.28572 5.76503 2.62085 4.82532 3.24875C3.88561 3.87664 3.15319 4.76909 2.72069 5.81324C2.28819 6.85739 2.17503 8.00634 2.39552 9.11481C2.616 10.2233 3.16024 11.2415 3.95939 12.0406C4.75855 12.8398 5.77674 13.384 6.8852 13.6045C7.99367 13.825 9.14262 13.7118 10.1868 13.2793C11.2309 12.8468 12.1234 12.1144 12.7513 11.1747C13.3792 10.235 13.7143 9.13018 13.7143 8C13.7125 6.48504 13.1099 5.03264 12.0386 3.9614C10.9674 2.89015 9.51497 2.28753 8 2.28572Z"
      fill="currentColor"
    />
    <path
      d="M10.047 11.1029C9.92777 11.1029 9.80985 11.078 9.70081 11.0298C9.59178 10.9816 9.49403 10.9111 9.41386 10.8229L7.367 8.57714C7.2226 8.42159 7.14114 8.21794 7.13843 8.00571V5.42857C7.13843 5.20124 7.22873 4.98322 7.38948 4.82248C7.55022 4.66173 7.76824 4.57143 7.99557 4.57143C8.2229 4.57143 8.44092 4.66173 8.60166 4.82248C8.76241 4.98322 8.85271 5.20124 8.85271 5.42857V7.66743L10.6813 9.66743C10.793 9.79035 10.8666 9.94302 10.8932 10.1069C10.9198 10.2709 10.8983 10.439 10.8313 10.5909C10.7643 10.7429 10.6546 10.8721 10.5156 10.963C10.3766 11.0539 10.2142 11.1024 10.0481 11.1029H10.047Z"
      fill="currentColor"
    />
  </svg>
);

export const LoggedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M12.0714 12.7083H2.64286C2.47236 12.7083 2.30885 12.776 2.18829 12.8966C2.06773 13.0171 2 13.1806 2 13.3511C2 13.5216 2.06773 13.6852 2.18829 13.8057C2.30885 13.9263 2.47236 13.994 2.64286 13.994H12.0714C12.2419 13.994 12.4054 13.9263 12.526 13.8057C12.6466 13.6852 12.7143 13.5216 12.7143 13.3511C12.7143 13.1806 12.6466 13.0171 12.526 12.8966C12.4054 12.776 12.2419 12.7083 12.0714 12.7083Z"
        fill="currentColor"
      />
      <path
        d="M13.6238 3.27972L12.7144 2.37029C12.4694 2.13674 12.1439 2.00645 11.8054 2.00645C11.4669 2.00645 11.1414 2.13674 10.8964 2.37029L5.14669 8.11915C5.08473 8.1815 5.04343 8.2614 5.02841 8.34801L4.57155 10.9237C4.56027 10.986 4.56294 11.0501 4.57937 11.1112C4.59579 11.1724 4.62556 11.2291 4.66655 11.2774C4.70753 11.3257 4.7587 11.3643 4.81637 11.3904C4.87405 11.4166 4.93681 11.4296 5.00012 11.4286C5.02515 11.4288 5.05013 11.4265 5.07469 11.4217L7.65041 10.9674C7.73712 10.9522 7.81703 10.9106 7.87927 10.8483L13.6281 5.09943C13.8692 4.85833 14.0046 4.53136 14.0046 4.19043C14.0046 3.84951 13.8692 3.52254 13.6281 3.28143L13.6238 3.27972Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="12" height="12" fill="currentColor" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

/** :'( */
export const SmallBrain = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.7066 2C10.2918 2 10.7972 2.46565 10.9834 3.01348C11.1696 2.90391 11.3824 2.84913 11.6218 2.84913C12.3666 2.84913 12.9784 3.47913 12.9784 4.24609C12.9784 4.32885 12.9708 4.41162 12.9571 4.49291L12.8718 4.45C12.8688 4.45678 12.861 4.47354 12.8487 4.4988C12.827 4.54317 12.8013 4.5932 12.7717 4.6474C12.687 4.80257 12.5897 4.95768 12.4827 5.10057C12.267 5.38853 12.0434 5.58287 11.8388 5.64885C11.7751 5.66939 11.7066 5.68204 11.6333 5.68695C11.3971 5.7028 11.1255 5.63822 10.8511 5.51809C10.7625 5.47932 10.6806 5.43775 10.608 5.39652C10.5663 5.37282 10.5385 5.35556 10.527 5.34794L10.1 6.0778C10.1267 6.0956 10.1706 6.12283 10.2295 6.15632C10.3248 6.21042 10.4307 6.26417 10.5454 6.31437C10.9229 6.47963 11.3076 6.57109 11.6839 6.54585C11.8173 6.5369 11.9469 6.51297 12.0718 6.47269C12.4618 6.34694 12.8038 6.04965 13.1121 5.63811C13.2459 5.45945 13.3647 5.27006 13.468 5.08072C13.4854 5.04894 13.5013 5.01897 13.5159 4.99105C13.996 5.20718 14.335 5.70217 14.335 6.27304C14.335 6.65652 14.1754 7.01261 13.936 7.25913C14.5478 7.53304 15 8.16304 15 8.90261C15 9.53938 14.6752 10.0881 14.2175 10.3937L14.2139 10.3692C13.3764 10.4792 12.5139 10.3195 12.1335 9.97517C11.9743 9.83012 11.8463 9.67261 11.7471 9.5049C11.494 9.07736 11.4407 8.62233 11.5012 8.22387C11.5085 8.17613 11.515 8.14532 11.518 8.1344L10.8643 7.95C10.8548 7.98544 10.8427 8.04185 10.8314 8.11666C10.7482 8.66369 10.8205 9.27952 11.1676 9.8661C11.2124 9.9418 11.2614 10.0157 11.3145 10.0878C10.5867 10.1927 10.0154 10.5164 9.59539 10.9937C9.41441 11.1994 9.27513 11.4189 9.17147 11.6391C9.10774 11.7746 9.06899 11.8841 9.05 11.9555L9.83417 12.15C9.83498 12.147 9.83926 12.133 9.84746 12.1098C9.86282 12.0664 9.88304 12.0168 9.90855 11.9626C9.9827 11.8051 10.0831 11.6469 10.2124 11.4999C10.5808 11.0812 11.1066 10.8318 11.85 10.8318L11.8498 10.6272C12.3751 10.9917 13.1996 11.1486 14.0309 11.0869C14.056 11.2063 14.069 11.3282 14.069 11.45C14.069 12.4361 13.2976 13.2304 12.34 13.2304C12.1538 13.2304 11.9676 13.203 11.808 13.1483C11.6484 13.97 10.9568 14.6 10.1056 14.6C9.148 14.6 8.3766 13.833 8.3766 12.847H8.35V3.26L8.3543 3.2065C8.41452 2.66697 8.98583 2 9.7066 2ZM6.2934 2C7.01417 2 7.58548 2.66697 7.6457 3.2065L7.65 3.26V12.847H7.6234C7.6234 13.833 6.852 14.6 5.8944 14.6C5.28795 14.6 4.76251 14.2802 4.45277 13.7991C5.97359 13.2467 6.6808 12.018 5.97604 10.6236C5.7284 10.1386 5.35247 9.798 4.88699 9.58927C4.42307 9.38125 3.94584 9.32768 3.53426 9.35773C3.49715 9.36044 3.46877 9.3634 3.45 9.36588L3.5671 10.0463C3.56903 10.046 3.5801 10.0449 3.59931 10.0435C3.87783 10.0231 4.21575 10.0611 4.53004 10.202C4.83864 10.3404 5.08678 10.5652 5.25963 10.9038C5.76283 11.8993 5.30463 12.7322 4.19237 13.1493C4.19209 13.1487 4.19205 13.1485 4.192 13.1483C4.0324 13.203 3.8462 13.2304 3.66 13.2304C2.7024 13.2304 1.931 12.4361 1.931 11.45C1.931 11.1487 2.0108 10.8474 2.1438 10.5735C1.5054 10.3543 1 9.69696 1 8.90261C1 8.16304 1.4522 7.53304 2.064 7.25913C1.8246 7.01261 1.665 6.65652 1.665 6.27304C1.665 5.69524 2.01224 5.19517 2.50199 4.98365L2.49775 4.97277C2.58192 5.19865 2.69759 5.42334 2.85022 5.63298C3.14926 6.04375 3.55197 6.34417 4.06514 6.48646C4.36082 6.56844 4.63995 6.56873 4.90058 6.50093L4.85 6.48482C5.28683 6.61189 5.6288 6.82512 5.89339 7.10174C6.04343 7.2586 6.15928 7.42592 6.24861 7.59734C6.27464 7.64731 6.37907 7.89738 6.43125 7.95L6.88892 7.48128C6.92512 7.51778 6.93429 7.53414 6.94962 7.56714C6.94989 7.56762 6.93217 7.52408 6.92471 7.50621C6.89476 7.43448 6.86264 7.36471 6.82283 7.28832C6.70607 7.06427 6.55501 6.84609 6.35932 6.6415C6.15461 6.42748 5.91474 6.24324 5.63754 6.0956C5.69465 6.04631 5.75043 5.9929 5.8048 5.9361C5.93014 5.80517 6.03851 5.66529 6.1303 5.52473C6.18698 5.43794 6.22687 5.36747 6.25 5.3213L5.70347 4.88843C5.6941 4.90712 5.66974 4.95015 5.63112 5.00929C5.56409 5.11194 5.48403 5.21527 5.39206 5.31135C5.05583 5.66257 4.66381 5.82074 4.20422 5.69331C3.82363 5.58778 3.53772 5.37449 3.32664 5.08455C3.22061 4.93891 3.14032 4.78294 3.08264 4.62815C3.06984 4.5938 3.05941 4.56318 3.05113 4.53705C3.03224 4.4421 3.0216 4.34409 3.0216 4.24609C3.0216 3.47913 3.6334 2.84913 4.3782 2.84913C4.6176 2.84913 4.8304 2.90391 5.0166 3.01348C5.2028 2.46565 5.7082 2 6.2934 2Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="14" height="12.6" fill="currentColor" transform="translate(1 2)" />
      </clipPath>
    </defs>
  </svg>
);

export const MoneyBills = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <g transform="matrix(0.8571428571428571,0,0,0.8571428571428571,0,0)">
      <path
        d="M0.500 2.500 L11.500 2.500 L11.500 9.500 L0.500 9.500 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M4.500 6.000 A1.500 1.500 0 1 0 7.500 6.000 A1.500 1.500 0 1 0 4.500 6.000 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M3.5,11.5h9a1,1,0,0,0,1-1v-5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);

export const Info = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" height="16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="matrix(1.1428571428571428,0,0,1.1428571428571428,0,0)">
      <path
        d="M7,0a7,7,0,1,0,7,7A7.008,7.008,0,0,0,7,0Zm.75,10.5a.75.75,0,0,1-1.5,0V7a.75.75,0,0,1,1.5,0ZM7,5A1,1,0,1,1,8,4,1,1,0,0,1,7,5Z"
        fill="currentColor"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);

export const Billable = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    data-testid="billable-icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 1C6.61553 1 5.26216 1.41054 4.11101 2.17971C2.95987 2.94888 2.06266 4.04213 1.53285 5.32122C1.00303 6.6003 0.86441 8.00777 1.13451 9.36563C1.4046 10.7235 2.07129 11.9708 3.05026 12.9497C4.02922 13.9287 5.2765 14.5954 6.63437 14.8655C7.99224 15.1356 9.39971 14.997 10.6788 14.4672C11.9579 13.9373 13.0511 13.0401 13.8203 11.889C14.5895 10.7378 15 9.38447 15 8C15 6.14349 14.2625 4.36301 12.9498 3.05025C11.637 1.7375 9.85652 1 8 1ZM8.75 12.135V12.75C8.75 12.9489 8.67099 13.1397 8.53033 13.2803C8.38968 13.421 8.19892 13.5 8 13.5C7.80109 13.5 7.61033 13.421 7.46967 13.2803C7.32902 13.1397 7.25 12.9489 7.25 12.75V12.133C6.80378 11.9908 6.40604 11.727 6.10149 11.3713C5.79694 11.0155 5.59764 10.5818 5.526 10.119C5.50444 9.92562 5.55877 9.73141 5.67755 9.5773C5.79634 9.42318 5.97031 9.32118 6.16281 9.2928C6.35531 9.26441 6.55131 9.31184 6.70953 9.42511C6.86775 9.53837 6.97583 9.70862 7.011 9.9C7.04836 10.1498 7.17884 10.3762 7.37625 10.5337C7.57366 10.6913 7.82336 10.7683 8.07521 10.7493C8.32705 10.7303 8.56239 10.6167 8.73393 10.4313C8.90548 10.246 9.00053 10.0026 9 9.75C8.99889 9.60076 8.95432 9.45507 8.87174 9.33076C8.78916 9.20644 8.67215 9.10888 8.535 9.05L6.874 8.333C6.46593 8.15882 6.1181 7.86848 5.87379 7.4981C5.62948 7.12773 5.4995 6.69369 5.5 6.25C5.49997 5.71798 5.66966 5.19983 5.98439 4.77089C6.29913 4.34195 6.74249 4.02461 7.25 3.865V3.25C7.25 3.05109 7.32902 2.86032 7.46967 2.71967C7.61033 2.57902 7.80109 2.5 8 2.5C8.19892 2.5 8.38968 2.57902 8.53033 2.71967C8.67099 2.86032 8.75 3.05109 8.75 3.25V3.867C9.19623 4.00917 9.59397 4.27296 9.89852 4.62874C10.2031 4.98452 10.4024 5.41819 10.474 5.881C10.5029 6.07775 10.4526 6.27795 10.3342 6.43767C10.2157 6.5974 10.0387 6.7036 9.842 6.733C9.74426 6.74885 9.64433 6.74494 9.54812 6.72151C9.45191 6.69808 9.36137 6.65561 9.28185 6.5966C9.20234 6.53759 9.13545 6.46324 9.08515 6.37795C9.03485 6.29265 9.00216 6.19814 8.989 6.1C8.95165 5.85022 8.82116 5.62382 8.62376 5.46628C8.42635 5.30875 8.17665 5.23174 7.9248 5.25073C7.67295 5.26973 7.43762 5.38331 7.26608 5.56867C7.09453 5.75403 6.99947 5.99744 7 6.25C7.00014 6.4001 7.04426 6.54686 7.1269 6.67216C7.20954 6.79745 7.32708 6.89578 7.465 6.955L9.126 7.667C9.53408 7.84118 9.88191 8.13153 10.1262 8.5019C10.3705 8.87227 10.5005 9.30631 10.5 9.75C10.5 10.282 10.3303 10.8002 10.0156 11.2291C9.70088 11.658 9.25752 11.9754 8.75 12.135Z"
      fill="currentColor"
    />
  </svg>
);

export const NonBillable = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    data-testid="non-billable-icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5124 1.94496C10.4544 1.33127 9.24426 1 8 1C6.61553 1 5.26216 1.41054 4.11101 2.17971C2.95987 2.94888 2.06266 4.04213 1.53285 5.32122C1.00303 6.6003 0.86441 8.00777 1.13451 9.36563C1.26751 10.0343 1.49668 10.6761 1.81195 11.2723L5.82226 7.41623C5.61125 7.06449 5.49953 6.66139 5.5 6.25C5.49997 5.71798 5.66966 5.19983 5.98439 4.77089C6.29913 4.34195 6.74249 4.02461 7.25 3.865V3.25C7.25 3.05109 7.32902 2.86032 7.46967 2.71967C7.61033 2.57902 7.80109 2.5 8 2.5C8.19892 2.5 8.38968 2.57902 8.53033 2.71967C8.67099 2.86032 8.75 3.05109 8.75 3.25V3.867C8.93264 3.92519 9.10715 4.00375 9.27047 4.10065L11.5124 1.94496ZM8.07444 5.25067C8.02491 5.24698 7.9749 5.24695 7.9248 5.25073C7.67295 5.26973 7.43762 5.38331 7.26608 5.56867C7.09453 5.75403 6.99947 5.99744 7 6.25C7.00001 6.26105 7.00026 6.27207 7.00075 6.28307L8.07444 5.25067ZM8.87528 9.33613L7.52659 10.6329C7.69354 10.7227 7.88375 10.7637 8.07521 10.7493C8.32705 10.7303 8.56239 10.6167 8.73393 10.4313C8.90548 10.246 9.00053 10.0026 9 9.75C8.99891 9.6029 8.9556 9.45926 8.87528 9.33613ZM6.42801 11.6893C6.67091 11.8863 6.94946 12.0372 7.25 12.133V12.75C7.25 12.9489 7.32902 13.1397 7.46967 13.2803C7.61033 13.421 7.80109 13.5 8 13.5C8.19892 13.5 8.38968 13.421 8.53033 13.2803C8.67099 13.1397 8.75 12.9489 8.75 12.75V12.135C9.25752 11.9754 9.70088 11.658 10.0156 11.2291C10.3303 10.8002 10.5 10.282 10.5 9.75C10.5005 9.30631 10.3705 8.87227 10.1262 8.5019C10.0769 8.42707 10.0233 8.35552 9.96583 8.28752L14.0054 4.40335C14.6508 5.48117 15 6.72259 15 8C15 9.38447 14.5895 10.7378 13.8203 11.889C13.0511 13.0401 11.9579 13.9373 10.6788 14.4672C9.39971 14.997 7.99224 15.1356 6.63437 14.8655C5.75204 14.69 4.91639 14.347 4.17072 13.8597L6.42801 11.6893Z"
        fill="currentColor"
      />
      <path
        d="M2.07941 13.4206L13.9206 2.07939"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const Team = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M7.9286 0.428543C7.70677 0.428459 7.48603 0.459623 7.27289 0.521115C7.24092 0.530325 7.21153 0.546854 7.18705 0.569392C7.16258 0.591931 7.14368 0.619859 7.13187 0.650965C7.12006 0.682072 7.11566 0.715501 7.11901 0.748605C7.12236 0.781708 7.13337 0.813577 7.15118 0.841686C7.51906 1.42335 7.71434 2.09745 7.71434 2.78569C7.71434 3.47392 7.51906 4.14803 7.15118 4.72969C7.13337 4.7578 7.12236 4.78966 7.11901 4.82277C7.11566 4.85587 7.12006 4.8893 7.13187 4.92041C7.14368 4.95151 7.16258 4.97944 7.18705 5.00198C7.21153 5.02452 7.24092 5.04105 7.27289 5.05026C7.59702 5.14388 7.93748 5.16683 8.27125 5.11755C8.60502 5.06828 8.92432 4.94792 9.20757 4.76463C9.49082 4.58134 9.73142 4.33937 9.91312 4.05509C10.0948 3.77081 10.2134 3.45083 10.2608 3.11679C10.3081 2.78275 10.2833 2.44243 10.1878 2.11883C10.0924 1.79523 9.92857 1.49589 9.70748 1.24104C9.48639 0.98619 9.21317 0.781773 8.90628 0.641602C8.59939 0.501432 8.26599 0.428775 7.9286 0.428543Z"
        fill="currentColor"
      />
      <path
        d="M7.9286 0.428543C7.70677 0.428459 7.48603 0.459623 7.27289 0.521115C7.24092 0.530325 7.21153 0.546854 7.18705 0.569392C7.16258 0.591931 7.14368 0.619859 7.13187 0.650965C7.12006 0.682072 7.11566 0.715501 7.11901 0.748605C7.12236 0.781708 7.13337 0.813577 7.15118 0.841686C7.51906 1.42335 7.71434 2.09745 7.71434 2.78569C7.71434 3.47392 7.51906 4.14803 7.15118 4.72969C7.13337 4.7578 7.12236 4.78966 7.11901 4.82277C7.11566 4.85587 7.12006 4.8893 7.13187 4.92041C7.14368 4.95151 7.16258 4.97944 7.18705 5.00198C7.21153 5.02452 7.24092 5.04105 7.27289 5.05026C7.59702 5.14388 7.93748 5.16683 8.27125 5.11755C8.60502 5.06828 8.92432 4.94792 9.20757 4.76463C9.49082 4.58134 9.73142 4.33937 9.91312 4.05509C10.0948 3.77081 10.2134 3.45083 10.2608 3.11679C10.3081 2.78275 10.2833 2.44243 10.1878 2.11883C10.0924 1.79523 9.92857 1.49589 9.70748 1.24104C9.48639 0.98619 9.21317 0.781773 8.90628 0.641602C8.59939 0.501432 8.26599 0.428775 7.9286 0.428543Z"
        stroke="currentColor"
      />
      <path
        d="M8.32886 6.44739C8.23115 6.43797 8.13343 6.43282 8.03743 6.43025C7.99506 6.42912 7.9533 6.44059 7.91744 6.4632C7.88159 6.4858 7.85324 6.51854 7.83599 6.55726C7.81874 6.59598 7.81336 6.63895 7.82054 6.68073C7.82771 6.72251 7.84711 6.76122 7.87629 6.79197C8.87214 7.83953 9.4278 9.22945 9.42858 10.6748C9.4293 10.8855 9.40045 11.0953 9.34286 11.298C9.33362 11.3298 9.33191 11.3633 9.33786 11.3959C9.34381 11.4284 9.35726 11.4592 9.37715 11.4857C9.3972 11.5122 9.4231 11.5337 9.45284 11.5486C9.48257 11.5635 9.51533 11.5713 9.54858 11.5714H11.1429C11.3702 11.5714 11.5882 11.4811 11.749 11.3203C11.9097 11.1596 12 10.9416 12 10.7143V10.6748C12.017 9.64151 11.6517 8.63834 10.974 7.85804C10.2964 7.07774 9.35437 6.57535 8.32886 6.44739Z"
        fill="currentColor"
      />
      <path
        d="M8.32886 6.44739C8.23115 6.43797 8.13343 6.43282 8.03743 6.43025C7.99506 6.42912 7.9533 6.44059 7.91744 6.4632C7.88159 6.4858 7.85324 6.51854 7.83599 6.55726C7.81874 6.59598 7.81336 6.63895 7.82054 6.68073C7.82771 6.72251 7.84711 6.76122 7.87629 6.79197C8.87214 7.83953 9.4278 9.22945 9.42858 10.6748C9.4293 10.8855 9.40045 11.0953 9.34286 11.298C9.33362 11.3298 9.33191 11.3633 9.33786 11.3959C9.34381 11.4284 9.35726 11.4592 9.37715 11.4857C9.3972 11.5122 9.4231 11.5337 9.45284 11.5486C9.48257 11.5635 9.51533 11.5713 9.54858 11.5714H11.1429C11.3702 11.5714 11.5882 11.4811 11.749 11.3203C11.9097 11.1596 12 10.9416 12 10.7143V10.6748C12.017 9.64151 11.6517 8.63834 10.974 7.85804C10.2964 7.07774 9.35437 6.57535 8.32886 6.44739Z"
        stroke="currentColor"
      />
      <path
        d="M1.71429 2.78569C1.71429 3.41084 1.96264 4.01039 2.40469 4.45244C2.84674 4.89449 3.44628 5.14283 4.07144 5.14283C4.69659 5.14283 5.29614 4.89449 5.73819 4.45244C6.18024 4.01039 6.42858 3.41084 6.42858 2.78569C6.42858 2.16053 6.18024 1.56098 5.73819 1.11893C5.29614 0.676884 4.69659 0.428543 4.07144 0.428543C3.44628 0.428543 2.84674 0.676884 2.40469 1.11893C1.96264 1.56098 1.71429 2.16053 1.71429 2.78569Z"
        fill="currentColor"
      />
      <path
        d="M1.71429 2.78569C1.71429 3.41084 1.96264 4.01039 2.40469 4.45244C2.84674 4.89449 3.44628 5.14283 4.07144 5.14283C4.69659 5.14283 5.29614 4.89449 5.73819 4.45244C6.18024 4.01039 6.42858 3.41084 6.42858 2.78569C6.42858 2.16053 6.18024 1.56098 5.73819 1.11893C5.29614 0.676884 4.69659 0.428543 4.07144 0.428543C3.44628 0.428543 2.84674 0.676884 2.40469 1.11893C1.96264 1.56098 1.71429 2.16053 1.71429 2.78569Z"
        stroke="currentColor"
      />
      <path
        d="M0 10.7143C0 10.9416 0.0903059 11.1596 0.251051 11.3204C0.411797 11.4811 0.629814 11.5714 0.857143 11.5714H7.28571C7.51304 11.5714 7.73106 11.4811 7.89181 11.3204C8.05255 11.1596 8.14286 10.9416 8.14286 10.7143V10.6748C8.1599 9.64153 7.79451 8.63836 7.11689 7.85806C6.43927 7.07777 5.49722 6.57538 4.47171 6.44742C3.90602 6.3918 3.33496 6.45519 2.79524 6.63353C2.25552 6.81186 1.7591 7.10119 1.33792 7.4829C0.916732 7.8646 0.580102 8.33024 0.349679 8.84986C0.119256 9.36948 0.00014286 9.93157 0 10.5L0 10.7143Z"
        fill="currentColor"
      />
      <path
        d="M0 10.7143C0 10.9416 0.0903059 11.1596 0.251051 11.3204C0.411797 11.4811 0.629814 11.5714 0.857143 11.5714H7.28571C7.51304 11.5714 7.73106 11.4811 7.89181 11.3204C8.05255 11.1596 8.14286 10.9416 8.14286 10.7143V10.6748C8.1599 9.64153 7.79451 8.63836 7.11689 7.85806C6.43927 7.07777 5.49722 6.57538 4.47171 6.44742C3.90602 6.3918 3.33496 6.45519 2.79524 6.63353C2.25552 6.81186 1.7591 7.10119 1.33792 7.4829C0.916732 7.8646 0.580102 8.33024 0.349679 8.84986C0.119256 9.36948 0.00014286 9.93157 0 10.5L0 10.7143Z"
        stroke="currentColor"
      />
    </g>
  </svg>
);

export const Warning = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M6 4.28569V6.85712"
        stroke="currentColor"
        strokeWidth="1.14286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M5.57141 9.42857C5.57141 9.54224 5.61656 9.65125 5.69694 9.73162C5.77731 9.81199 5.88632 9.85714 5.99998 9.85714C6.11365 9.85714 6.22266 9.81199 6.30303 9.73162C6.3834 9.65125 6.42855 9.54224 6.42855 9.42857C6.42855 9.31491 6.3834 9.2059 6.30303 9.12553C6.22266 9.04515 6.11365 9 5.99998 9C5.88632 9 5.77731 9.04515 5.69694 9.12553C5.61656 9.2059 5.57141 9.31491 5.57141 9.42857Z"
        stroke="currentColor"
        strokeWidth="1.14286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M6.76627 0.902544C6.69501 0.76036 6.5856 0.640806 6.45027 0.557257C6.31494 0.473708 6.15903 0.429459 5.99999 0.429459C5.84094 0.429459 5.68504 0.473708 5.54971 0.557257C5.41438 0.640806 5.30496 0.76036 5.2337 0.902544L0.519416 10.3311C0.454132 10.4618 0.423313 10.6069 0.429884 10.7528C0.436456 10.8987 0.480199 11.0405 0.556963 11.1648C0.633728 11.289 0.740967 11.3916 0.868506 11.4628C0.996044 11.5339 1.13965 11.5713 1.2857 11.5714H10.7143C10.8603 11.5713 11.0039 11.5339 11.1315 11.4628C11.259 11.3916 11.3662 11.289 11.443 11.1648C11.5198 11.0405 11.5635 10.8987 11.5701 10.7528C11.5767 10.6069 11.5458 10.4618 11.4806 10.3311L6.76627 0.902544Z"
        stroke="currentColor"
        strokeWidth="1.14286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const MessageBubble: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <g transform="matrix(2,0,0,2,0,0)">
      <path d="M12,1.37C5.68,1.37.54,5.61.54,10.82A8.56,8.56,0,0,0,3.7,17.33L1.42,21.9a.5.5,0,0,0,.08.57.51.51,0,0,0,.57.11L8.2,19.73a13.78,13.78,0,0,0,3.8.53c6.32,0,11.46-4.24,11.46-9.44S18.32,1.37,12,1.37Zm5,12.25H7.5a.75.75,0,1,1,0-1.5H17a.75.75,0,0,1,0,1.5ZM6.75,8.37a.76.76,0,0,1,.75-.75H14a.75.75,0,1,1,0,1.5H7.5A.75.75,0,0,1,6.75,8.37Z" />
    </g>
  </svg>
);

export const WarningDiamond = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M14.6441 7.1425L8.85165 1.35C8.62538 1.12487 8.31917 0.998489 7.99998 0.998489C7.68079 0.998489 7.37459 1.12487 7.14832 1.35L1.35582 7.14833C1.24364 7.25999 1.15463 7.3927 1.0939 7.53886C1.03316 7.68501 1.00189 7.84173 1.00189 8C1.00189 8.15827 1.03316 8.31498 1.0939 8.46114C1.15463 8.60729 1.24364 8.74001 1.35582 8.85167L7.14832 14.6383C7.25811 14.7535 7.3903 14.845 7.53676 14.9072C7.68323 14.9694 7.84086 15.001 7.99998 15C8.15932 15.0002 8.31713 14.9689 8.4643 14.9078C8.61147 14.8467 8.7451 14.7571 8.85748 14.6442L14.6441 8.8575C14.8714 8.62999 14.9991 8.32157 14.9991 8C14.9991 7.67843 14.8714 7.37001 14.6441 7.1425ZM7.41665 4.745C7.41665 4.59029 7.47811 4.44192 7.5875 4.33252C7.6969 4.22312 7.84527 4.16167 7.99998 4.16167C8.15469 4.16167 8.30307 4.22312 8.41246 4.33252C8.52186 4.44192 8.58332 4.59029 8.58332 4.745V8.245C8.58332 8.39971 8.52186 8.54808 8.41246 8.65748C8.30307 8.76687 8.15469 8.82833 7.99998 8.82833C7.84527 8.82833 7.6969 8.76687 7.5875 8.65748C7.47811 8.54808 7.41665 8.39971 7.41665 8.245V4.745ZM8.02915 11.4592C7.79983 11.4564 7.58024 11.3661 7.41538 11.2066C7.25053 11.0472 7.15289 10.8308 7.14248 10.6017C7.13776 10.4861 7.15645 10.3709 7.19743 10.2628C7.23841 10.1546 7.30082 10.0559 7.38092 9.97257C7.46102 9.8892 7.55716 9.82288 7.66354 9.77762C7.76993 9.73235 7.88437 9.70907 7.99998 9.70917C8.22771 9.71346 8.44518 9.80465 8.60785 9.96407C8.77052 10.1235 8.86609 10.3391 8.87498 10.5667C8.87887 10.681 8.85999 10.795 8.81944 10.902C8.77889 11.009 8.71748 11.1068 8.63878 11.1899C8.56008 11.2729 8.46565 11.3395 8.361 11.3857C8.25634 11.4319 8.14354 11.4569 8.02915 11.4592Z"
        fill="currentColor"
      />
    </svg>
  )
);

export const Play = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <g transform="matrix(2,0,0,2,0,0)">
      <path d="M23.14,10.61,2.25.16A1.56,1.56,0,0,0,0,1.56V22.44a1.56,1.56,0,0,0,2.25,1.4L23.14,13.39A1.55,1.55,0,0,0,23.14,10.61Z" />
    </g>
  </svg>
));

export const Pause = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="currentColor"
      ref={ref}
      {...props}
    >
      <g transform="matrix(2,0,0,2,0,0)">
        <rect x="3" y="1" width="7" height="22" rx="1.5" />
        <rect x="14" y="1" width="7" height="22" rx="1.5" />
      </g>
    </svg>
  )
);

export const MemoryApp = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
      <path
        d="M0 14.2222C0 7.5178 0 4.16559 2.0828 2.0828C4.16559 0 7.5178 0 14.2222 0H17.7778C24.4822 0 27.8344 0 29.9172 2.0828C32 4.16559 32 7.5178 32 14.2222V17.7778C32 24.4822 32 27.8344 29.9172 29.9172C27.8344 32 24.4822 32 17.7778 32H14.2222C7.5178 32 4.16559 32 2.0828 29.9172C0 27.8344 0 24.4822 0 17.7778V14.2222Z"
        fill="#FE435E"
      />
      <path
        d="M20.5065 19.1416L20.527 19.1606C21.2105 19.7854 22.488 20.038 23.7374 19.8936C23.7486 19.9886 23.7561 20.0836 23.7561 20.1785C23.7561 21.4415 22.7663 22.4576 21.5374 22.4576C21.2983 22.4576 21.0611 22.4196 20.8557 22.3531C20.6503 23.4072 19.7631 24.2143 18.6706 24.2143C17.4436 24.2143 16.4537 23.2267 16.4537 21.9638H16.4192V9.6864C16.4537 8.9837 17.2036 8.07208 18.1598 8.07208C18.9068 8.07208 19.5512 8.66843 19.794 9.37019C20.0274 9.23059 20.3076 9.16127 20.6064 9.16127C21.5589 9.16127 22.3432 9.96843 22.3432 10.9494C22.3432 11.0918 22.3246 11.2342 22.2966 11.37L22.2592 11.4365C22.1565 11.6169 22.0444 11.7945 21.9137 11.9588C21.6541 12.2893 21.3908 12.5134 21.148 12.5893C21.0695 12.6121 20.9892 12.6273 20.9015 12.633C20.6213 12.652 20.301 12.576 19.977 12.4383C19.8743 12.3937 19.7753 12.3462 19.6894 12.2988C19.638 12.2798 19.6053 12.2513 19.5913 12.2513L19.0871 13.0964C19.1151 13.1154 19.1711 13.1505 19.2365 13.1895C19.3485 13.2521 19.4746 13.3129 19.61 13.3699C20.0582 13.5598 20.513 13.6643 20.9594 13.6358C21.1181 13.6263 21.2675 13.5978 21.4169 13.5503C21.8791 13.4079 22.2854 13.066 22.6495 12.5912C22.8083 12.3871 22.9484 12.1696 23.0697 11.9521L23.0819 11.937C23.6683 12.2247 24.0783 12.8429 24.0783 13.5513C24.0783 14.0422 23.8728 14.498 23.5647 14.8142C24.3491 15.1656 24.9299 15.9728 24.9299 16.9195C24.9299 17.8909 24.3323 18.7029 23.5665 19.0181C22.5487 19.1254 21.5308 18.9203 21.0667 18.4987C20.8641 18.3088 20.7026 18.1094 20.5765 17.8909C20.2553 17.3459 20.188 16.7638 20.2646 16.2548C20.2739 16.1931 20.2833 16.1532 20.2851 16.1408L19.4541 15.9034C19.4447 15.9509 19.426 16.0212 19.4139 16.1171C19.3112 16.8103 19.3999 17.5909 19.8304 18.3354C19.172 18.4911 18.6482 18.8386 18.2523 19.3201C18.059 19.5518 17.9105 19.8044 17.804 20.0513C17.734 20.2051 17.692 20.3295 17.6733 20.4121L18.5044 20.6334L18.5175 20.5907C18.5361 20.5394 18.5548 20.4862 18.5828 20.4216C18.6641 20.2412 18.7696 20.0608 18.9078 19.8946C19.272 19.4521 19.7762 19.1758 20.4738 19.1378L20.5065 19.1416ZM11.9369 13.6909C11.7194 13.6975 11.4934 13.6747 11.2599 13.6215C10.5652 13.463 10.0198 13.1278 9.61456 12.6691C9.40912 12.4412 9.25037 12.1848 9.13832 11.9379L9.12151 11.8999C8.49866 12.1753 8.05697 12.8115 8.05697 13.5522C8.05697 14.046 8.26241 14.5018 8.57056 14.8152C7.78803 15.1656 7.20721 15.9728 7.20721 16.9224C7.20721 17.9384 7.85527 18.7836 8.67328 19.0618C8.50333 19.4132 8.40248 19.7987 8.40248 20.1852C8.40248 21.4481 9.39044 22.4699 10.6193 22.4699C10.8229 22.4699 11.0274 22.4433 11.2104 22.3939C12.4879 21.846 13.0192 20.7321 12.4487 19.398C12.2554 18.9497 11.9771 18.6516 11.6306 18.4673C11.2777 18.2812 10.8995 18.23 10.5866 18.2584L10.5493 18.2622L10.4186 17.3601C10.4372 17.3601 10.4653 17.3506 10.5119 17.3506C10.9695 17.3126 11.5111 17.3791 12.0247 17.6545C12.5476 17.9299 12.9678 18.3857 13.248 19.0314C14.023 20.8451 13.2667 22.45 11.6232 23.2002C12.0247 23.8079 12.7064 24.2162 13.4814 24.2162C14.7047 24.2162 15.6946 23.2381 15.6946 21.9752H15.7282V9.6864C15.7048 8.9837 14.9522 8.07208 13.996 8.07208C13.2461 8.07208 12.5981 8.66843 12.359 9.37019C12.1209 9.23059 11.8473 9.16127 11.5401 9.16127C10.5848 9.16127 9.80038 9.96843 9.80038 10.9494C9.80038 11.0852 9.81626 11.22 9.84427 11.352L9.85361 11.3492C9.86108 11.3776 9.88443 11.4536 9.92831 11.5486C10.0077 11.729 10.1151 11.8999 10.2598 12.0614C10.54 12.3842 10.9322 12.6216 11.4457 12.7451C12.0621 12.8875 12.5943 12.7166 13.0519 12.3177C13.1733 12.2133 13.2853 12.0993 13.3694 11.9854C13.4161 11.9189 13.4534 11.8714 13.4628 11.8524L14.2005 12.3367C14.1678 12.3909 14.1164 12.4697 14.0371 12.5646C13.9129 12.7232 13.7663 12.878 13.5982 13.0204C13.4693 13.1344 13.3367 13.2294 13.1966 13.3148C13.4768 13.4952 13.7289 13.7042 13.9465 13.9321C14.2079 14.2169 14.4134 14.5113 14.5693 14.8247C14.6254 14.9291 14.6692 15.0241 14.7094 15.1248L14.7421 15.2074C14.7206 15.1637 14.7066 15.1409 14.6599 15.0906L14.0436 15.7325C13.9717 15.6565 13.8316 15.3147 13.7961 15.2482C13.6766 15.0108 13.5207 14.7829 13.3199 14.5645C12.965 14.1847 12.5037 13.8903 11.9192 13.7175L11.922 13.708L11.9369 13.6909Z"
        fill="white"
      />
    </svg>
  )
);

export const DollarCircle = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <mask id="path-1-inside-1_420_4" fill="white">
        <path d="M7 0C5.61553 0 4.26215 0.410543 3.11101 1.17971C1.95986 1.94888 1.06266 3.04213 0.532843 4.32122C0.00302923 5.6003 -0.135594 7.00777 0.134502 8.36563C0.404599 9.7235 1.07128 10.9708 2.05025 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67878 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14349 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0ZM7.75 11.135V11.75C7.75 11.9489 7.67098 12.1397 7.53033 12.2803C7.38968 12.421 7.19891 12.5 7 12.5C6.80109 12.5 6.61032 12.421 6.46967 12.2803C6.32902 12.1397 6.25 11.9489 6.25 11.75V11.133C5.80377 10.9908 5.40603 10.727 5.10148 10.3713C4.79693 10.0155 4.59764 9.58182 4.526 9.119C4.50443 8.92562 4.55876 8.73141 4.67755 8.5773C4.79634 8.42318 4.9703 8.32118 5.1628 8.2928C5.3553 8.26441 5.55131 8.31184 5.70953 8.42511C5.86775 8.53837 5.97583 8.70862 6.011 8.9C6.04835 9.14978 6.17884 9.37618 6.37625 9.53372C6.57365 9.69126 6.82336 9.76826 7.0752 9.74927C7.32705 9.73028 7.56238 9.61669 7.73393 9.43133C7.90548 9.24597 8.00053 9.00256 8 8.75C7.99889 8.60076 7.95432 8.45507 7.87174 8.33076C7.78916 8.20644 7.67214 8.10888 7.535 8.05L5.874 7.333C5.46593 7.15882 5.11809 6.86848 4.87379 6.4981C4.62948 6.12773 4.49949 5.69369 4.5 5.25C4.49997 4.71798 4.66966 4.19983 4.98439 3.77089C5.29912 3.34195 5.74249 3.02461 6.25 2.865V2.25C6.25 2.05109 6.32902 1.86032 6.46967 1.71967C6.61032 1.57902 6.80109 1.5 7 1.5C7.19891 1.5 7.38968 1.57902 7.53033 1.71967C7.67098 1.86032 7.75 2.05109 7.75 2.25V2.867C8.19623 3.00917 8.59397 3.27296 8.89852 3.62874C9.20307 3.98452 9.40236 4.41819 9.474 4.881C9.50293 5.07775 9.45264 5.27795 9.33416 5.43767C9.21568 5.5974 9.03868 5.7036 8.842 5.733C8.74426 5.74885 8.64433 5.74494 8.54812 5.72151C8.45191 5.69808 8.36137 5.65561 8.28185 5.5966C8.20233 5.53759 8.13545 5.46324 8.08515 5.37795C8.03485 5.29265 8.00216 5.19814 7.989 5.1C7.95165 4.85022 7.82116 4.62382 7.62375 4.46628C7.42635 4.30875 7.17664 4.23174 6.9248 4.25073C6.67295 4.26973 6.43762 4.38331 6.26607 4.56867C6.09452 4.75403 5.99947 4.99744 6 5.25C6.00014 5.4001 6.04425 5.54686 6.12689 5.67216C6.20954 5.79745 6.32708 5.89578 6.465 5.955L8.126 6.667C8.53407 6.84118 8.88191 7.13153 9.12621 7.5019C9.37052 7.87227 9.50051 8.30631 9.5 8.75C9.50003 9.28202 9.33034 9.80018 9.01561 10.2291C8.70088 10.658 8.25751 10.9754 7.75 11.135Z" />
      </mask>
      <path
        d="M7 0C5.61553 0 4.26215 0.410543 3.11101 1.17971C1.95986 1.94888 1.06266 3.04213 0.532843 4.32122C0.00302923 5.6003 -0.135594 7.00777 0.134502 8.36563C0.404599 9.7235 1.07128 10.9708 2.05025 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67878 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14349 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0ZM7.75 11.135V11.75C7.75 11.9489 7.67098 12.1397 7.53033 12.2803C7.38968 12.421 7.19891 12.5 7 12.5C6.80109 12.5 6.61032 12.421 6.46967 12.2803C6.32902 12.1397 6.25 11.9489 6.25 11.75V11.133C5.80377 10.9908 5.40603 10.727 5.10148 10.3713C4.79693 10.0155 4.59764 9.58182 4.526 9.119C4.50443 8.92562 4.55876 8.73141 4.67755 8.5773C4.79634 8.42318 4.9703 8.32118 5.1628 8.2928C5.3553 8.26441 5.55131 8.31184 5.70953 8.42511C5.86775 8.53837 5.97583 8.70862 6.011 8.9C6.04835 9.14978 6.17884 9.37618 6.37625 9.53372C6.57365 9.69126 6.82336 9.76826 7.0752 9.74927C7.32705 9.73028 7.56238 9.61669 7.73393 9.43133C7.90548 9.24597 8.00053 9.00256 8 8.75C7.99889 8.60076 7.95432 8.45507 7.87174 8.33076C7.78916 8.20644 7.67214 8.10888 7.535 8.05L5.874 7.333C5.46593 7.15882 5.11809 6.86848 4.87379 6.4981C4.62948 6.12773 4.49949 5.69369 4.5 5.25C4.49997 4.71798 4.66966 4.19983 4.98439 3.77089C5.29912 3.34195 5.74249 3.02461 6.25 2.865V2.25C6.25 2.05109 6.32902 1.86032 6.46967 1.71967C6.61032 1.57902 6.80109 1.5 7 1.5C7.19891 1.5 7.38968 1.57902 7.53033 1.71967C7.67098 1.86032 7.75 2.05109 7.75 2.25V2.867C8.19623 3.00917 8.59397 3.27296 8.89852 3.62874C9.20307 3.98452 9.40236 4.41819 9.474 4.881C9.50293 5.07775 9.45264 5.27795 9.33416 5.43767C9.21568 5.5974 9.03868 5.7036 8.842 5.733C8.74426 5.74885 8.64433 5.74494 8.54812 5.72151C8.45191 5.69808 8.36137 5.65561 8.28185 5.5966C8.20233 5.53759 8.13545 5.46324 8.08515 5.37795C8.03485 5.29265 8.00216 5.19814 7.989 5.1C7.95165 4.85022 7.82116 4.62382 7.62375 4.46628C7.42635 4.30875 7.17664 4.23174 6.9248 4.25073C6.67295 4.26973 6.43762 4.38331 6.26607 4.56867C6.09452 4.75403 5.99947 4.99744 6 5.25C6.00014 5.4001 6.04425 5.54686 6.12689 5.67216C6.20954 5.79745 6.32708 5.89578 6.465 5.955L8.126 6.667C8.53407 6.84118 8.88191 7.13153 9.12621 7.5019C9.37052 7.87227 9.50051 8.30631 9.5 8.75C9.50003 9.28202 9.33034 9.80018 9.01561 10.2291C8.70088 10.658 8.25751 10.9754 7.75 11.135Z"
        fill={props.fill || '#697077'}
      />
      <path
        d="M14 7H24H14ZM7.75 11.75H17.75H7.75ZM6.25 11.133H16.25V3.82369L9.2856 1.60488L6.25 11.133ZM4.526 9.119L-5.41238 10.2274L-5.38882 10.4387L-5.35631 10.6487L4.526 9.119ZM6.011 8.9L15.901 7.42099L15.8764 7.25619L15.8463 7.0923L6.011 8.9ZM8 8.75L18 8.72901L17.9999 8.70232L17.9997 8.67564L8 8.75ZM7.535 8.05L3.5718 17.2311L3.58088 17.235L3.58996 17.2389L7.535 8.05ZM5.874 7.333L9.8372 -1.84813L9.81848 -1.85621L9.79972 -1.86421L5.874 7.333ZM4.5 5.25L14.5 5.26145L14.5 5.24939L4.5 5.25ZM6.25 2.865L9.25 12.4044L16.25 10.203V2.865H6.25ZM7 1.5V-8.5V1.5ZM7.75 2.25H17.75H7.75ZM7.75 2.867H-2.25V10.1763L4.7144 12.3951L7.75 2.867ZM9.474 4.881L19.3676 3.42627L19.3621 3.38876L19.3563 3.35129L9.474 4.881ZM8.842 5.733L7.36382 -4.15715L7.30279 -4.14802L7.24187 -4.13815L8.842 5.733ZM7.989 5.1L17.9003 3.77136L17.8903 3.6961L17.879 3.62099L7.989 5.1ZM6 5.25L16 5.24086L16 5.22901L6 5.25ZM6.465 5.955L2.51969 15.1438L2.52514 15.1462L6.465 5.955ZM8.126 6.667L4.18614 15.8582L4.19321 15.8612L4.20028 15.8642L8.126 6.667ZM9.5 8.75L-0.500001 8.73855L-0.5 8.75061L9.5 8.75ZM7 -10C3.63772 -10 0.350941 -9.00297 -2.44469 -7.13498L8.66671 9.49441C8.17336 9.82405 7.59334 10 7 10V-10ZM-2.44469 -7.13498C-5.24033 -5.267 -7.41926 -2.61196 -8.70595 0.494382L9.77164 8.14805C9.54458 8.69623 9.16006 9.16476 8.66671 9.49441L-2.44469 -7.13498ZM-8.70595 0.494382C-9.99264 3.60073 -10.3293 7.01886 -9.67335 10.3165L9.94236 6.41473C10.0581 6.99667 9.9987 7.59987 9.77164 8.14805L-8.70595 0.494382ZM-9.67335 10.3165C-9.0174 13.6142 -7.39831 16.6433 -5.02082 19.0208L9.12132 4.87868C9.54088 5.29824 9.8266 5.83279 9.94236 6.41473L-9.67335 10.3165ZM-5.02082 19.0208C-2.64332 21.3983 0.385789 23.0174 3.68347 23.6734L7.58527 4.05765C8.16721 4.1734 8.70176 4.45912 9.12132 4.87868L-5.02082 19.0208ZM3.68347 23.6734C6.98114 24.3293 10.3993 23.9926 13.5056 22.706L5.85195 4.22836C6.40013 4.0013 7.00333 3.94189 7.58527 4.05765L3.68347 23.6734ZM13.5056 22.706C16.612 21.4193 19.267 19.2403 21.135 16.4447L4.50559 5.33329C4.83524 4.83994 5.30377 4.45543 5.85195 4.22836L13.5056 22.706ZM21.135 16.4447C23.003 13.6491 24 10.3623 24 7H4C4 6.40666 4.17595 5.82664 4.50559 5.33329L21.135 16.4447ZM24 7C24 2.49132 22.2089 -1.8327 19.0208 -5.02081L4.87868 9.12132C4.31607 8.55871 4 7.79565 4 7H24ZM19.0208 -5.02081C15.8327 -8.20893 11.5087 -10 7 -10V10C6.20435 10 5.44129 9.68393 4.87868 9.12132L19.0208 -5.02081ZM-2.25 11.135V11.75H17.75V11.135H-2.25ZM-2.25 11.75C-2.25 9.29675 -1.27545 6.94397 0.459263 5.20926L14.6014 19.3514C16.6174 17.3354 17.75 14.6011 17.75 11.75H-2.25ZM0.459263 5.20926C2.19397 3.47456 4.54674 2.5 7 2.5V22.5C9.85109 22.5 12.5854 21.3674 14.6014 19.3514L0.459263 5.20926ZM7 2.5C9.45326 2.5 11.806 3.47456 13.5407 5.20926L-0.601398 19.3514C1.41461 21.3674 4.14891 22.5 7 22.5V2.5ZM13.5407 5.20926C15.2754 6.94397 16.25 9.29675 16.25 11.75H-3.75C-3.75 14.6011 -2.61741 17.3354 -0.601398 19.3514L13.5407 5.20926ZM16.25 11.75V11.133H-3.75V11.75H16.25ZM9.2856 1.60488C10.6115 2.02731 11.7934 2.81115 12.6983 3.86832L-2.49534 16.8742C-0.981299 18.6429 0.996015 19.9544 3.2144 20.6611L9.2856 1.60488ZM12.6983 3.86832C13.6033 4.92548 14.1954 6.21408 14.4083 7.58929L-5.35631 10.6487C-5.00015 12.9496 -4.00938 15.1055 -2.49534 16.8742L12.6983 3.86832ZM14.4644 8.01059C14.73 10.3922 14.0609 12.784 12.5979 14.682L-3.24284 2.4726C-4.94335 4.67887 -5.72113 7.45903 -5.41238 10.2274L14.4644 8.01059ZM12.5979 14.682C11.135 16.58 8.99251 17.8362 6.62177 18.1858L3.70384 -1.6002C0.948098 -1.1938 -1.54234 0.266323 -3.24284 2.4726L12.5979 14.682ZM6.62177 18.1858C4.25103 18.5354 1.83712 17.9512 -0.111431 16.5563L11.5305 0.293904C9.2655 -1.32755 6.45958 -2.00661 3.70384 -1.6002L6.62177 18.1858ZM-0.111431 16.5563C-2.05998 15.1614 -3.39106 13.0646 -3.82425 10.7077L15.8463 7.0923C15.3427 4.35263 13.7955 1.91536 11.5305 0.293904L-0.111431 16.5563ZM-3.87902 10.379C-3.46813 13.1266 -2.03279 15.617 0.138684 17.3499L12.6138 1.71753C14.3905 3.13536 15.5648 5.17295 15.901 7.42099L-3.87902 10.379ZM0.138684 17.3499C2.31016 19.0828 5.05691 19.9299 7.82722 19.721L6.32319 -0.222415C8.58981 -0.393351 10.8372 0.299701 12.6138 1.71753L0.138684 17.3499ZM7.82722 19.721C10.5975 19.512 13.1862 18.2626 15.0732 16.2236L0.39467 2.63903C1.93859 0.970783 4.05658 -0.051479 6.32319 -0.222415L7.82722 19.721ZM15.0732 16.2236C16.9602 14.1846 18.0058 11.5072 18 8.72901L-1.99998 8.77099C-2.00475 6.49796 -1.14926 4.3073 0.39467 2.63903L15.0732 16.2236ZM17.9997 8.67564C17.9842 6.58316 17.3593 4.54053 16.2014 2.79749L-0.457907 13.864C-1.45062 12.3696 -1.98638 10.6184 -1.99972 8.82436L17.9997 8.67564ZM16.2014 2.79749C15.0435 1.05446 13.4029 -0.313427 11.48 -1.13894L3.58996 17.2389C1.94142 16.5312 0.534802 15.3584 -0.457907 13.864L16.2014 2.79749ZM11.4982 -1.13113L9.8372 -1.84813L1.9108 16.5141L3.5718 17.2311L11.4982 -1.13113ZM9.79972 -1.86421C11.1957 -1.26836 12.3856 -0.275131 13.2213 0.991859L-3.47374 12.0043C-2.14939 14.0121 -0.263823 15.586 1.94828 16.5302L9.79972 -1.86421ZM13.2213 0.991859C14.0571 2.25885 14.5017 3.74365 14.5 5.26145L-5.49999 5.23855C-5.50275 7.64373 -4.7981 9.99661 -3.47374 12.0043L13.2213 0.991859ZM14.5 5.24939C14.5001 6.84545 13.991 8.39992 13.0468 9.68672L-3.07805 -2.14495C-4.65171 -0.000264185 -5.50016 2.59052 -5.5 5.25061L14.5 5.24939ZM13.0468 9.68672C12.1026 10.9735 10.7725 11.9256 9.25 12.4044L3.25 -6.67439C0.712435 -5.87636 -1.50438 -4.28963 -3.07805 -2.14495L13.0468 9.68672ZM16.25 2.865V2.25H-3.75V2.865H16.25ZM16.25 2.25C16.25 4.70325 15.2755 7.05602 13.5407 8.79074L-0.601398 -5.3514C-2.61742 -3.33538 -3.75 -0.601074 -3.75 2.25H16.25ZM13.5407 8.79074C11.806 10.5254 9.45325 11.5 7 11.5V-8.5C4.14892 -8.5 1.41462 -7.36741 -0.601398 -5.3514L13.5407 8.79074ZM7 11.5C4.54675 11.5 2.19397 10.5254 0.459263 8.79074L14.6014 -5.3514C12.5854 -7.36741 9.85108 -8.5 7 -8.5V11.5ZM0.459263 8.79074C-1.27545 7.05602 -2.25 4.70325 -2.25 2.25H17.75C17.75 -0.601074 16.6174 -3.33538 14.6014 -5.3514L0.459263 8.79074ZM-2.25 2.25V2.867H17.75V2.25H-2.25ZM4.7144 12.3951C3.38847 11.9727 2.20663 11.1888 1.30169 10.1317L16.4953 -2.8742C14.9813 -4.64293 13.004 -5.95436 10.7856 -6.66112L4.7144 12.3951ZM1.30169 10.1317C0.396747 9.07452 -0.195434 7.78592 -0.408307 6.41071L19.3563 3.35129C19.0002 1.05045 18.0094 -1.10547 16.4953 -2.8742L1.30169 10.1317ZM-0.419622 6.33573C-0.775914 3.91258 -0.156545 1.44706 1.3026 -0.520012L17.3657 11.3954C19.0618 9.10884 19.7818 6.24293 19.3676 3.42627L-0.419622 6.33573ZM1.3026 -0.520012C2.76175 -2.48709 4.94154 -3.79511 7.36382 -4.15715L10.3202 15.6231C13.1358 15.2023 15.6696 13.6819 17.3657 11.3954L1.3026 -0.520012ZM7.24187 -4.13815C8.46323 -4.33613 9.71187 -4.28731 10.914 -3.99458L6.18219 15.4376C7.57678 15.7772 9.02528 15.8338 10.4421 15.6041L7.24187 -4.13815ZM10.914 -3.99458C12.1162 -3.70185 13.2475 -3.17115 14.2411 -2.4338L2.3226 13.627C3.47525 14.4824 4.78763 15.098 6.18219 15.4376L10.914 -3.99458ZM14.2411 -2.4338C15.2347 -1.69645 16.0704 -0.767446 16.6989 0.298318L-0.528639 10.4576C0.20045 11.6939 1.16995 12.7716 2.3226 13.627L14.2411 -2.4338ZM16.6989 0.298318C17.3274 1.36411 17.736 2.54505 17.9003 3.77136L-1.92234 6.42864C-1.73164 7.85123 -1.25775 9.2212 -0.528639 10.4576L16.6989 0.298318ZM17.879 3.62099C17.4681 0.873375 16.0328 -1.617 13.8613 -3.34991L1.38619 12.2825C-0.390468 10.8646 -1.56484 8.82706 -1.90102 6.57901L17.879 3.62099ZM13.8613 -3.34991C11.6898 -5.08281 8.94309 -5.92987 6.17278 -5.72095L7.67681 14.2224C5.4102 14.3934 3.16285 13.7003 1.38619 12.2825L13.8613 -3.34991ZM6.17278 -5.72095C3.40248 -5.51203 0.813831 -4.2626 -1.07319 -2.22362L13.6053 11.361C12.0614 13.0292 9.94342 14.0515 7.67681 14.2224L6.17278 -5.72095ZM-1.07319 -2.22362C-2.96021 -0.184649 -4.00581 2.49283 -3.99998 5.27099L16 5.22901C16.0047 7.50205 15.1493 9.69271 13.6053 11.361L-1.07319 -2.22362ZM-4 5.25914C-3.99807 7.3636 -3.37953 9.42137 -2.22083 11.1781L14.4746 0.166208C15.468 1.67235 15.9983 3.43659 16 5.24086L-4 5.25914ZM-2.22083 11.1781C-1.06213 12.9348 0.585947 14.3136 2.51969 15.1438L10.4103 -3.23383C12.0682 -2.52199 13.4812 -1.33995 14.4746 0.166208L-2.22083 11.1781ZM2.52514 15.1462L4.18614 15.8582L12.0659 -2.52416L10.4049 -3.23616L2.52514 15.1462ZM4.20028 15.8642C2.80431 15.2684 1.61442 14.2751 0.778682 13.0081L17.4737 1.99565C16.1494 -0.0120762 14.2638 -1.586 12.0517 -2.53021L4.20028 15.8642ZM0.778682 13.0081C-0.0570583 11.7411 -0.501732 10.2563 -0.499993 8.73855L19.5 8.76145C19.5027 6.35627 18.7981 4.00339 17.4737 1.99565L0.778682 13.0081ZM-0.5 8.75061C-0.500097 7.15456 0.00897002 5.60009 0.953172 4.31328L17.078 16.1449C18.6517 14.0003 19.5002 11.4095 19.5 8.74939L-0.5 8.75061ZM0.953172 4.31328C1.89737 3.02647 3.22746 2.07443 4.75 1.59561L10.75 20.6744C13.2876 19.8764 15.5044 18.2896 17.078 16.1449L0.953172 4.31328Z"
        fill={props.fill || '#697077'}
        mask="url(#path-1-inside-1_420_4)"
      />
    </svg>
  )
);

export const CrossInCircle = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM15.7071 8.29289C16.0976 8.68342 16.0976 9.31658 15.7071 9.70711L13.4142 12L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L12 13.4142L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L10.5858 12L8.29289 9.70711C7.90237 9.31658 7.90237 8.68342 8.29289 8.29289C8.68342 7.90237 9.31658 7.90237 9.70711 8.29289L12 10.5858L14.2929 8.29289C14.6834 7.90237 15.3166 7.90237 15.7071 8.29289Z"
        fill="currentColor"
      />
    </svg>
  )
);

export const UserOutline = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M5.99999 7.5C4.41495 7.5 3.00539 8.26532 2.10798 9.45298C1.91484 9.7086 1.81827 9.83641 1.82143 10.0091C1.82387 10.1426 1.90767 10.3109 2.01267 10.3933C2.14858 10.5 2.33692 10.5 2.7136 10.5H9.28637C9.66305 10.5 9.85139 10.5 9.9873 10.3933C10.0923 10.3109 10.1761 10.1426 10.1785 10.0091C10.1817 9.83641 10.0851 9.7086 9.89199 9.45298C8.99459 8.26532 7.58502 7.5 5.99999 7.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99999 6C7.24263 6 8.24999 4.99264 8.24999 3.75C8.24999 2.50736 7.24263 1.5 5.99999 1.5C4.75735 1.5 3.74999 2.50736 3.74999 3.75C3.74999 4.99264 4.75735 6 5.99999 6Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
);
export const BriefcaseOutline = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 3.5C8 3.03501 8 2.80252 7.94889 2.61177C7.81019 2.09413 7.40587 1.68981 6.88823 1.55111C6.69748 1.5 6.46499 1.5 6 1.5C5.53501 1.5 5.30252 1.5 5.11177 1.55111C4.59413 1.68981 4.18981 2.09413 4.05111 2.61177C4 2.80252 4 3.03501 4 3.5M2.6 10.5H9.4C9.96005 10.5 10.2401 10.5 10.454 10.391C10.6422 10.2951 10.7951 10.1422 10.891 9.95399C11 9.74008 11 9.46005 11 8.9V5.1C11 4.53995 11 4.25992 10.891 4.04601C10.7951 3.85785 10.6422 3.70487 10.454 3.60899C10.2401 3.5 9.96005 3.5 9.4 3.5H2.6C2.03995 3.5 1.75992 3.5 1.54601 3.60899C1.35785 3.70487 1.20487 3.85785 1.10899 4.04601C1 4.25992 1 4.53995 1 5.1V8.9C1 9.46005 1 9.74008 1.10899 9.95399C1.20487 10.1422 1.35785 10.2951 1.54601 10.391C1.75992 10.5 2.03995 10.5 2.6 10.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
);

export const Webhooks = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 19.5H12.01M22.8064 8.70076C19.9595 6.09199 16.1656 4.5 11.9999 4.5C7.83414 4.5 4.04023 6.09199 1.19336 8.70076M4.73193 12.243C6.67006 10.5357 9.21407 9.5 12 9.5C14.7859 9.5 17.3299 10.5357 19.268 12.243M15.6983 15.7751C14.6792 14.9763 13.3952 14.5 11.9999 14.5C10.5835 14.5 9.28172 14.9908 8.25537 15.8116"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CodeFile = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 18.5C5 18.9644 5 19.1966 5.02567 19.3916C5.2029 20.7378 6.26222 21.7971 7.60842 21.9743C7.80337 22 8.03558 22 8.5 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V9.98822C21 9.25445 21 8.88757 20.9171 8.5423C20.8436 8.2362 20.7224 7.94356 20.5579 7.67515C20.3724 7.3724 20.113 7.11296 19.5941 6.59411L16.4059 3.40589C15.887 2.88703 15.6276 2.6276 15.3249 2.44208C15.0564 2.27759 14.7638 2.15638 14.4577 2.08289C14.1124 2 13.7455 2 13.0118 2H8.5C8.03558 2 7.80337 2 7.60842 2.02567C6.26222 2.2029 5.2029 3.26222 5.02567 4.60842C5 4.80337 5 5.03558 5 5.5M9 14.5L11.5 12L9 9.5M5 9.5L2.5 12L5 14.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MessageBox = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H15.2C16.8802 18 17.7202 18 18.362 17.673C18.9265 17.3854 19.3854 16.9265 19.673 16.362C20 15.7202 20 14.8802 20 13.2V13M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ErrorHexagon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 8.00008V12.0001M12 16.0001H12.01M3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7985 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586V7.94153C21 7.59889 21 7.42756 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7985 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42756 3 7.59889 3 7.94153Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SwitchArrows = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 17H4M4 17L8 13M4 17L8 21M4 7H20M20 7L16 3M20 7L16 11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Copy = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 2.0028C9.82495 2.01194 9.4197 2.05103 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8.05103 3.4197 8.01194 3.82495 8.0028 4.5M19.5 2.0028C20.1751 2.01194 20.5803 2.05103 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C21.949 3.4197 21.9881 3.82494 21.9972 4.49999M21.9972 13.5C21.9881 14.175 21.949 14.5803 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.5803 15.949 20.1751 15.9881 19.5 15.9972M22 7.99999V9.99999M14.0001 2H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlayCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM9.59974 8.11608C9.5 8.24931 9.5 8.48795 9.5 8.96524V15.0346C9.5 15.5119 9.5 15.7505 9.59974 15.8837C9.68666 15.9998 9.81971 16.0725 9.96438 16.0828C10.1304 16.0947 10.3311 15.9656 10.7326 15.7075L15.4532 12.6728C15.8016 12.4489 15.9758 12.3369 16.0359 12.1945C16.0885 12.0701 16.0885 11.9297 16.0359 11.8053C15.9758 11.6629 15.8016 11.5509 15.4532 11.327L10.7326 8.2923C10.3311 8.0342 10.1304 7.90515 9.96438 7.91701C9.81971 7.92734 9.68666 7.99998 9.59974 8.11608Z"
    />
  </svg>
);

export const InfoCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReverseLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.70711 3.70711C9.09763 3.31658 9.09763 2.68342 8.70711 2.29289C8.31658 1.90237 7.68342 1.90237 7.29289 2.29289L3.29289 6.29289C2.90237 6.68342 2.90237 7.31658 3.29289 7.70711L7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071C9.09763 11.3166 9.09763 10.6834 8.70711 10.2929L6.41421 8L14 8C16.7614 8 19 10.2386 19 13C19 15.7614 16.7614 18 14 18H4C3.44772 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20H14C17.866 20 21 16.866 21 13C21 9.13401 17.866 6 14 6L6.41421 6L8.70711 3.70711Z"
      fill="currentColor"
    />
  </svg>
);

export const MessageDotsCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 12H7.51M12 12H12.01M16.5 12H16.51M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21ZM8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const Refresh2 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.54661 19.7675C10.9457 20.8319 13.8032 20.7741 16.2502 19.3613C20.3157 17.0141 21.7086 11.8156 19.3614 7.75008L19.1114 7.31706M4.63851 16.2502C2.2913 12.1847 3.68424 6.98619 7.74972 4.63898C10.1967 3.22621 13.0542 3.16841 15.4533 4.23277M2.49341 16.3338L5.22546 17.0659L5.95751 14.3338M18.0426 9.6659L18.7747 6.93385L21.5067 7.6659"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Exclamation = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.005 3.1a1 1 0 1 1 1.99 0l-.388 6.35a.61.61 0 0 1-1.214 0L7.005 3.1ZM7 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
        stroke="currentColor"
      />
    </svg>
  );
};

export const SortAsc = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 8H8M3.5 4H12M3.5 12H7M9.5 10.5L12 13M12 13L14.5 10.5M12 13V7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SortDesc = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.5 8H8M3.5 12H12M3.5 4H7M9.5 5.5L12 3M12 3L14.5 5.5M12 3V9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Imports = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H20V2H6ZM18 4H6C5.44772 4 5 4.44772 5 5V19C5 19.5523 5.44772 20 6 20H18V4Z"
      fill="currentColor"
    />
    <path
      d="M20 17H6C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19H20V17Z"
      fill="currentColor"
    />
  </svg>
);

export const List = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke="none" fill="none" fillRule="evenodd">
      <g transform="translate(-165, -229)" fill="currentColor">
        <g transform="translate(165, 229)">
          <rect x="0" y="0" width="11" height="2" rx="1"></rect>
          <rect x="0" y="3" width="11" height="2" rx="1"></rect>
          <rect x="0" y="6" width="11" height="2" rx="1"></rect>
          <rect x="0" y="9" width="8.25" height="2" rx="1"></rect>
        </g>
      </g>
    </g>
  </svg>
);

export const ShortList = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="11"
    height="6"
    viewBox="0 0 11 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke="none" fill="none" fillRule="evenodd">
      <g transform="translate(-165, -392)" fill="currentColor">
        <g transform="translate(165, 392)">
          <rect x="0" y="0" width="11" height="2" rx="1"></rect>
          <rect x="0" y="3" width="6" height="2" rx="1"></rect>
        </g>
      </g>
    </g>
  </svg>
);

export const TimelyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="46px"
    height="45px"
    viewBox="0 0 46 45"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29.0619925,3.62733656e-15 C34.9517067,-2.107587e-15 37.0874594,0.613241538 39.2406509,1.76478095 C41.3938424,2.91632036 43.0836796,4.60615764 44.2352191,6.75934913 C45.3867585,8.91254062 46,11.0482933 46,16.9380075 L46,28.0619925 C46,33.9517067 45.3867585,36.0874594 44.2352191,38.2406509 C43.0836796,40.3938424 41.3938424,42.0836796 39.2406509,43.2352191 C37.0874594,44.3867585 34.9517067,45 29.0619925,45 L16.9380075,45 C11.0482933,45 8.91254062,44.3867585 6.75934913,43.2352191 C4.60615764,42.0836796 2.91632036,40.3938424 1.76478095,38.2406509 C0.613241538,36.0874594 0,33.9517067 0,28.0619925 L9.06834139e-16,16.9380075 C-5.2689675e-16,11.0482933 0.613241538,8.91254062 1.76478095,6.75934913 C2.91632036,4.60615764 4.60615764,2.91632036 6.75934913,1.76478095 C8.91254062,0.613241538 11.0482933,5.2689675e-16 16.9380075,-9.06834139e-16 L29.0619925,3.62733656e-15 Z M25.533758,20.1315789 L20.466242,20.1315789 L12.1052632,27.4100061 L14.4165697,30.0890948 L21.2332632,24.1535789 L21.208004,44.9955688 L24.7370531,45 L24.7622632,24.1505789 L31.5834303,30.0890948 L33.8947368,27.4100061 L25.533758,20.1315789 Z M33.2890607,13.3123193 L29.7050649,17.1603179 L31.3880888,18.6255092 L34.9723107,14.7774991 L33.2890607,13.3123193 Z M13.1165889,13.312363 L11.4333388,14.7775429 L15.0173346,18.6255415 L16.7005847,17.1603617 L13.1165889,13.312363 Z M24.2011209,8.28947368 L21.7894737,8.29276359 L21.7986379,15.3947368 L24.2105263,15.3916819 L24.2011209,8.28947368 Z"
      fill="#692AC3"
    />
  </svg>
);

export const ExpandIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M1 4.5V1H4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 7.5V11H7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RestoreIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M4.5 1V4.5H1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 11V7.5H11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
